<template>
  <div
    class="CDeviceComponent"
    v-loading="isLoading"
    element-loading-background="rgba(240, 243, 248, 0.7)"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
  >
    <div class="tit dkbTit1">设备{{ isDkbDeviceCenter ? "" : "类型" }}</div>
    <!-- 非数据看板显示 -->
    <el-tabs
      v-model="tabActive"
      @tab-click="tabClick"
      v-if="!isDkbDeviceCenter"
    >
      <el-tab-pane label="智慧空间" name="1">
        <p class="no-device" v-if="zhkjList.length == 0 && pageCount == 0">
          暂无设备
        </p>
        <swiper :options="swiperOption" ref="mySwiper1" v-else>
          <!-- slides -->
          <swiper-slide
            v-for="(item, index) in pageCount"
            :key="index"
            class="clearfix"
          >
            <div
              class="item"
              v-for="(zhkj, index2) in zhkjList[index]"
              :key="index2"
              @click="changeActive(zhkj.code)"
              :class="{ active: zhkj.code == isActive }"
            >
              <template v-if="zhkj.code">
                <div class="img">
                  <img :src="'/static/images/icon/' + zhkj.icon" alt="" />
                </div>
              </template>
              <div class="name">{{ zhkj.name }}</div>
            </div>
          </swiper-slide>
          <!-- Optional controls -->
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="el-icon-caret-left" slot="button-prev"></div>
          <div class="el-icon-caret-right" slot="button-next"></div>
        </swiper>
      </el-tab-pane>
      <el-tab-pane label="智慧供应链" name="2">
        <p class="no-device" v-if="zhgylList.length == 0 && pageCount2 == 0">
          暂无设备
        </p>
        <swiper :options="swiperOption" ref="mySwiper2" v-else>
          <!-- slides -->
          <swiper-slide
            v-for="(item, index) in pageCount2"
            :key="index"
            class="clearfix"
          >
            <div
              class="item"
              v-for="(zhgyl, index2) in zhgylList[index]"
              :key="index2"
              @click="changeActive(zhgyl.code)"
              :class="{ active: zhgyl.code == isActive }"
            >
              <template v-if="zhgyl.code">
                <div class="img">
                  <img :src="'/static/images/icon/' + zhgyl.icon" alt="" />
                </div>
              </template>
              <div class="name" :title="zhgyl.name">{{ zhgyl.name }}</div>
            </div>
          </swiper-slide>
          <!-- Optional controls -->
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="el-icon-caret-left" slot="button-prev"></div>
          <div class="el-icon-caret-right" slot="button-next"></div>
        </swiper>
      </el-tab-pane>
      <el-tab-pane label="第三方应用" name="3">
        <p class="no-device" v-if="thirdList.length == 0 && pageCount3 == 0">
          暂无设备
        </p>
        <swiper :options="swiperOption" ref="mySwiper2" v-else>
          <!-- slides -->
          <swiper-slide
            v-for="(item, index) in pageCount3"
            :key="index"
            class="clearfix"
          >
            <div
              class="item"
              v-for="(third, index3) in thirdList[index]"
              :key="index3"
              @click="changeActive(third.code)"
              :class="{ active: third.code == isActive }"
            >
              <template v-if="third.code">
                <div class="img">
                  <img :src="'/static/images/icon/' + third.icon" alt="" />
                </div>
              </template>
              <div class="name" :title="third.name">{{ third.name }}</div>
            </div>
          </swiper-slide>
          <!-- Optional controls -->
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="el-icon-caret-left" slot="button-prev"></div>
          <div class="el-icon-caret-right" slot="button-next"></div>
        </swiper>
      </el-tab-pane>
    </el-tabs>
    <!-- 数据看板显示 -->
    <div class="tabsBox" v-else>
      <p class="no-device" v-if="zhList.length == 0 && pageCount == 0">
        暂无设备
      </p>
      <swiper :options="swiperOption" ref="mySwiper1" v-else>
        <!-- slides -->
        <swiper-slide
          v-for="(item, index) in pageCount"
          :key="index"
          class="flex"
        >
          <div
            class="item"
            v-for="(zhkj, index2) in zhList[index]"
            :key="index2"
            @click="changeActive(zhkj.code)"
            :class="{ active: zhkj.code == isActive }"
          >
            <template v-if="zhkj.code">
              <!-- <div class="img"><img :src="zhkj.icon" alt=""></div> -->
              <div class="img" v-if="zhkj.code == isActive">
                <img
                  :src="'/static/images/dkb/dIcon/active/' + zhkj.icon"
                  alt=""
                />
              </div>
              <div class="img" v-else>
                <img
                  :src="'/static/images/dkb/dIcon/default/' + zhkj.icon"
                  alt=""
                />
              </div>
            </template>
            <div class="name">{{ zhkj.name }}</div>
          </div>
        </swiper-slide>
        <!-- Optional controls -->
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="el-icon-caret-left" slot="button-prev"></div>
        <div class="el-icon-caret-right" slot="button-next"></div>
      </swiper>
    </div>
    <div :class="[{ 'dcDkbScroll DkbScroll': isDkbDeviceCenter }]">
      <div class="tit bgd2 dkbTit2 dveTit">
        <div>设备列表</div>
        <div class="toggIcon">
          <el-radio-group
            v-model="isToggleShow"
            size="small"
            @change="toggleChangeList"
          >
            <el-radio-button label="1"
              ><i class="ico ico-menuTog1"></i
            ></el-radio-button>
            <el-radio-button label="2"
              ><i class="ico ico-menuTog2"></i
            ></el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div
        :class="['listCont', { mg20: !isDkbDeviceCenter }]"
        v-loading="dioLoading"
        element-loading-background="rgba(240, 243, 248, 0.7)"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
      >
        <!-- 水表电表显示 -->
        <div
          class="contBtn mb20"
          v-if="
            (isActive == 'ELECTRICMETER' || isActive == 'WATERMETER') &&
              !isDkbDeviceCenter
          "
        >
          <el-button
            class="btn"
            type="primary"
            @click="isEcharts = false"
            v-if="isEcharts == true"
            >查看详情</el-button
          >
          <el-button class="btn" type="primary" @click="isEcharts = true" v-else
            >查看总览</el-button
          >
        </div>
        <!-- 智能售卖柜显示 -->
        <div
          class="contBtn mb20"
          v-if="isActive == 'SELLBOX' && !isDkbDeviceCenter"
        >
          <el-button class="btn" type="primary" @click="getDeviceConfig"
            >设置</el-button
          >
        </div>
        <!-- 温湿度采集器 -->
        <!--<div class="contBtn mb20" v-if="(isActive == 'EPSENSOR')">
          <el-button class="btn" type="primary" @click="getEPSENSORWarning">预警情况</el-button>
        </div>-->
        <!-- 消毒一体机 -->
        <div class="contBtn mb20" v-if="isActive == 'THAIO'">
          <el-button class="btn" type="primary" @click="getTHAIORecord"
            >操作记录</el-button
          >
        </div>
        <!-- 密码保险柜 -->
        <div class="contBtn mb20" v-if="isActive == 'SECRECY'">
          <el-button class="btn" type="primary" @click="openSecrecyDio('early')"
            >预警记录</el-button
          >
          <el-button class="btn" type="primary" @click="openSecrecyDio('open')"
            >开门记录</el-button
          >
          <el-button
            class="btn"
            type="primary"
            @click="openSecrecyDio('setting')"
            >设置</el-button
          >
        </div>
        <template v-if="isEcharts == false">
          <p class="no-device" v-if="deviceList.length === 0">暂无设备</p>
          <div
            class="list"
            v-else-if="deviceList.length > 0 && isToggleShow == '1'"
          >
            <div class="li" v-for="(item, index) in deviceList" :key="index">
              <div class="liCont">
                <div class="name">
                  <span :title="item.device_name">{{ item.device_name }}</span>
                  <template
                    v-if="isActive !== 'CPL' && isActive !== 'VIDEOCLOUD'"
                  >
                    <span class="status" v-if="item.online == false">离线</span>
                    <span class="status onLine" v-if="item.online == true"
                      >在线</span
                    >
                  </template>
                  <template v-if="isActive == 'THAIO'">
                    <span
                      :class="['status onLine', { isNotSet: !runItem.is_set }]"
                      v-for="(runItem, runIndex) in item.run_mode"
                      :key="runIndex"
                    >
                      {{ runItem.name }}
                    </span>
                  </template>
                  <template v-if="isActive === 'VIDEOCLOUD'">
                    <span
                      :class="[
                        'status',
                        item.online_status == 1 ? 'onLine' : ''
                      ]"
                      >{{ item.online_status_text }}</span
                    >
                  </template>
                  <!-- <template v-if="isActive == 'CPL'">
                  <span class="status" v-if="item.online == false">占用中</span>
                  <span class="status onLine" v-if="item.online == true">空闲中</span>
                </template> -->
                </div>

                <el-popover
                  placement="top-start"
                  title=""
                  width="250"
                  trigger="click"
                  :content="item.device_no_id"
                >
                  <div slot="reference" class="tip" :title="item.device_no_id">
                    {{ isDkbDeviceCenter ? "设备号：" : ""
                    }}{{ item.device_no_id }}
                  </div>
                </el-popover>

                <div class="bot">
                  <div
                    class="detail"
                    @click="openDetail(index, 'detail')"
                    v-if="
                      isActive != 'ACCESS' &&
                        isActive != 'FEIBIFACE' &&
                        isActive != 'INVENTORYROBOT' &&
                        isActive != 'NODOORWAREHOUSE' &&
                        isActive != 'MULTIWAREHOUSE' &&
                        isActive != 'WAREHOUSE' &&
                        isActive != 'SOCKET' &&
                        isActive != 'CPL' &&
                        isActive != 'WATERLEAKAGE' &&
                        isActive != 'THAIO' &&
                        isActive != 'SECRECY' &&
                        isActive != 'VIDEOCLOUD'
                    "
                  >
                    详情
                  </div>
                  <div
                    v-if="
                      item.type == '2' &&
                        (isActive == 'ACCESS' || isActive == 'FEIBIFACE')
                    "
                    class="detail"
                    @click="openDetail(index)"
                  >
                    开门记录
                  </div>
                  <!-- 办公魔方柜 -->
                  <div
                    v-if="isActive == 'MAGICCUBE' && settingTag == 1"
                    class="detail"
                    @click="openSetting(index)"
                  >
                    设置
                  </div>
                  <!-- 保密柜显示 -->
                  <div
                    v-if="item.type == '1' && isActive == 'SAFEEXPRESS'"
                    class="detail"
                    @click="openDetail(index, 'address')"
                  >
                    当前位置
                  </div>
                  <!-- 车位锁显示 -->
                  <template v-if="isActive == 'CPL' && !isDkbDeviceCenter">
                    <div
                      class="detail"
                      @click="openDetail(index, 'authRecord')"
                    >
                      授权记录
                    </div>
                    <div
                      class="detail"
                      @click="openDetail(index, 'operateRecord')"
                    >
                      操作记录
                    </div>
                  </template>
                  <!-- 消毒一体机显示 -->
                  <div
                    v-if="isActive == 'THAIO'"
                    class="detail"
                    @click="openDetail(index, 'THAIOSetDio')"
                  >
                    设置模式
                  </div>
                  <!-- 消毒一体机显示 -->
                  <div
                    v-if="isActive == 'WATERLEAKAGE'"
                    class="detail"
                    @click="openDetail(index, 'WATERLEAKAGECofDio')"
                  >
                    配置线路
                  </div>
                  <!-- 密码保险柜显示 -->
                  <div
                    v-if="isActive == 'SECRECY'"
                    class="detail"
                    @click="openSecrecyDio('edit', item)"
                  >
                    修改密码
                  </div>
                  <!-- 视频云显示 -->
                  <div
                    v-if="isActive == 'VIDEOCLOUD'"
                    class="detail"
                    @click="openVIDEOCLOUDDio(index, item)"
                  >
                    实时浏览
                  </div>
                </div>
              </div>
              <div class="liRight">
                <template v-if="item.type == '1' && isActive != 'SECRECY'">
                  <el-button
                    class="btn"
                    size="mini"
                    disabled
                    v-if="item.online == false"
                    >重启</el-button
                  >
                  <el-button
                    class="btn restart"
                    size="mini"
                    v-else
                    @click="deviceControl(index)"
                    >重启</el-button
                  >
                </template>
                <template v-else-if="item.type == '2' && isActive == 'ACCESS'">
                  <el-button
                    class="btn"
                    size="mini"
                    disabled
                    v-if="item.online == false"
                    >开门</el-button
                  >
                  <el-button
                    class="btn restart"
                    size="mini"
                    v-else
                    @click="deviceControl(index)"
                    >开门</el-button
                  >
                </template>
                <template v-else-if="item.type == '3' && isActive == 'THAIO'">
                  <!-- openStatus:已开启on，已关闭off -->
                  <el-button
                    class="btn"
                    size="mini"
                    @click="deviceControl(index)"
                    >{{ item.openStatus == "on" ? "关闭" : "开启" }}</el-button
                  >
                </template>
                <template
                  v-else-if="
                    isActive == 'ELECTRICMETER' ||
                      isActive == 'SOCKET' ||
                      isActive == 'WATERMETER'
                  "
                >
                  <el-switch
                    v-model="item.isOpen"
                    active-color="#13ce66"
                    inactive-color="#d2d2d2"
                    :width="widthNum"
                    active-value="1"
                    inactive-value="2"
                    active-text="on"
                    inactive-text="off"
                    @change="deviceControl(index)"
                  >
                  </el-switch>
                </template>
              </div>
              <div class="time" v-if="isActive == 'SECRECY'">
                密码过期时间：{{ item.password_expire_time }}
              </div>
              <div
                class="ewm"
                v-if="item.type == '2' && isActive == 'ACCESS'"
                @click="previewImg(index)"
              ></div>
              <!-- 正式暂时不更新 -->
              <div
                class="ewm"
                v-if="item.type == '1' && isActive == 'MAGICCUBE'"
                @click="openDetail(index, 'codeList')"
              ></div>
            </div>
          </div>
          <div
            class="listTable"
            v-else-if="deviceList.length > 0 && isToggleShow == '2'"
          >
            <el-form
              :inline="true"
              :model="deviceKeyword"
              class="inlineform"
              v-if="!isDkbDeviceCenter"
            >
              <el-form-item label="">
                <el-input
                  v-model="deviceKeyword.device_no"
                  placeholder="请输入设备ID或者设备名称"
                  clearable
                  @keyup.enter.native="getEquipmentDeviceList(isActive)"
                ></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-input
                  v-model="deviceKeyword.address"
                  placeholder="请输入设备地址"
                  clearable
                  @keyup.enter.native="getEquipmentDeviceList(isActive)"
                ></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-button
                  type="primary"
                  @click="getEquipmentDeviceList(isActive)"
                  >搜索</el-button
                >
              </el-form-item>
            </el-form>
            <el-table class="DkbStripe" :data="deviceList" style="width:100%">
              <el-table-column
                label="序号"
                sortable
                type="index"
                width="80"
              ></el-table-column>
              <el-table-column
                label="设备ID"
                sortable
                prop="device_no_id"
              ></el-table-column>
              <el-table-column
                label="设备名称"
                sortable
                prop="device_name"
              ></el-table-column>
              <el-table-column
                label="设备状态"
                sortable
                prop="online"
                v-if="isActive !== 'CPL' && isActive !== 'VIDEOCLOUD'"
              >
                <template slot-scope="scope">
                  <span class="status" v-if="scope.row.online == false"
                    >离线</span
                  >
                  <span class="status onLine" v-if="scope.row.online == true"
                    >在线</span
                  >
                </template>
              </el-table-column>
              <!-- 云视频显示 -->
              <el-table-column
                label="设备状态"
                sortable
                v-if="isActive === 'VIDEOCLOUD'"
              >
                <template slot-scope="scope">
                  <span
                    :class="[
                      'status',
                      scope.row.online_status == 1 ? 'onLine' : ''
                    ]"
                    >{{ scope.row.online_status_text }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="运行模式" v-if="isActive === 'THAIO'">
                <template slot-scope="scope">
                  <span
                    :class="['status onLine', { isNotSet: !runItem.is_set }]"
                    v-for="(runItem, runIndex) in scope.row.run_mode"
                    :key="runIndex"
                  >
                    {{ runItem.name }}
                  </span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="车位状态" v-if="isActive == 'CPL'">
              <template slot-scope="scope">
                <span class="status" v-if="scope.row.online == false">占用中</span>
                <span class="status onLine" v-if="scope.row.online == true">空闲中</span>
              </template>
            </el-table-column> -->
              <el-table-column label="设备地址" sortable>
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="
                      scope.row.province_name +
                        scope.row.city_name +
                        scope.row.area_name +
                        scope.row.location
                    "
                    placement="top"
                  >
                    <span class="ellipsis">{{
                      scope.row.province_name +
                        scope.row.city_name +
                        scope.row.area_name +
                        scope.row.location
                    }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <!--门禁显示-->
              <el-table-column label="二维码" v-if="isActive == 'ACCESS'">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="previewImg(scope.$index)"
                    v-if="scope.row.type == '2'"
                    >查看</el-button
                  >
                </template>
              </el-table-column>
              <!--魔方柜显示-->
              <el-table-column
                label="二维码"
                v-else-if="isActive == 'MAGICCUBE'"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="openDetail(scope.$index, 'codeList')"
                    v-if="scope.row.type == '1'"
                    >查看</el-button
                  >
                </template>
              </el-table-column>
              <!--门禁显示-->
              <template v-if="isActive == 'ACCESS'">
                <el-table-column label="开门记录">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      v-if="scope.row.type == '2'"
                      @click="openDetail(scope.$index)"
                      >查看</el-button
                    >
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <template v-if="scope.row.type == '2'">
                      <el-button
                        class="btn"
                        size="mini"
                        disabled
                        v-if="scope.row.online == false"
                        >开门</el-button
                      >
                      <el-button
                        class="btn restart"
                        size="mini"
                        v-else
                        @click="deviceControl(scope.$index)"
                        >开门</el-button
                      >
                    </template>
                  </template>
                </el-table-column>
              </template>
              <!--车位锁显示-->
              <el-table-column
                label="授权记录"
                v-if="isActive == 'CPL' && !isDkbDeviceCenter"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="openDetail(scope.$index, 'authRecord')"
                    >查看</el-button
                  >
                </template>
              </el-table-column>
              <el-table-column
                label="操作记录"
                v-if="isActive == 'CPL' && !isDkbDeviceCenter"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="openDetail(scope.$index, 'operateRecord')"
                    >查看</el-button
                  >
                </template>
              </el-table-column>
              <!--柜类显示-->
              <el-table-column
                :label="isActive == 'SECRECY' ? '密码' : '箱格情况'"
                v-else-if="
                  isActive != 'ACCESS' &&
                    isActive != 'INVENTORYROBOT' &&
                    isActive != 'NODOORWAREHOUSE' &&
                    isActive != 'MULTIWAREHOUSE' &&
                    isActive != 'WAREHOUSE' &&
                    isActive != 'SOCKET' &&
                    isActive != 'CPL' &&
                    isActive != 'WATERLEAKAGE' &&
                    isActive != 'THAIO' &&
                    isActive != 'SECRECY' &&
                    isActive != 'VIDEOCLOUD'
                "
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="openSecrecyDio('edit', scope.row)"
                    v-if="isActive == 'SECRECY'"
                    >修改密码</el-button
                  >
                  <el-button
                    size="mini"
                    @click="openDetail(scope.$index, 'detail')"
                    v-else
                    >详情</el-button
                  >
                </template>
              </el-table-column>
              <el-table-column
                v-if="isActive == 'SECRECY'"
                label="密码过期"
                prop="password_expire_time"
              ></el-table-column>
              <!--保密柜显示-->
              <el-table-column
                label="当前位置"
                v-if="isActive == 'SAFEEXPRESS'"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    v-if="scope.row.type == '1'"
                    @click="openDetail(scope.$index, 'address')"
                    >查看</el-button
                  >
                </template>
              </el-table-column>
              <!--水电表、空调显示-->
              <el-table-column
                label="开关状态"
                v-if="
                  isActive == 'ELECTRICMETER' ||
                    isActive == 'SOCKET' ||
                    isActive == 'WATERMETER'
                "
              >
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.isOpen"
                    active-color="#13ce66"
                    inactive-color="#d2d2d2"
                    :width="widthNum"
                    active-value="1"
                    inactive-value="2"
                    active-text="on"
                    inactive-text="off"
                    @change="deviceControl(scope.$index)"
                  >
                  </el-switch>
                </template>
              </el-table-column>
              <!-- 云视频显示 -->
              <el-table-column label="操作" v-if="isActive === 'VIDEOCLOUD'">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="openVIDEOCLOUDDio(scope.$index, scope.row)"
                    >实时浏览</el-button
                  >
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                v-if="deviceList[0].type == 1 && isActive != 'SECRECY'"
              >
                <template slot-scope="scope">
                  <el-button
                    class="btn"
                    size="mini"
                    disabled
                    v-if="scope.row.online == false"
                    >重启</el-button
                  >
                  <el-button
                    class="btn restart"
                    size="mini"
                    v-else
                    @click="deviceControl(scope.$index)"
                    >重启</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <template v-if="!isDkbDeviceCenter">
              <div class="paging" v-if="tableTotal > 10">
                <el-pagination
                  @size-change="tableSizeChange"
                  @current-change="tableCurrentChange"
                  :current-page.sync="tableCurr"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="tablePage"
                  layout="sizes,prev, pager, next"
                  :total="tableTotal"
                >
                </el-pagination>
              </div>
            </template>
            <template v-else>
              <div class="paging" v-if="tableTotal > 9">
                <el-pagination
                  @current-change="tableCurrentChange"
                  :current-page.sync="tableCurr"
                  :page-size="tablePage"
                  layout="prev, pager, next, jumper"
                  :total="tableTotal"
                >
                </el-pagination>
              </div>
            </template>
          </div>
        </template>
        <template v-else>
          <!--电表的统计图-->
          <cammentermanage v-if="isActive == 'ELECTRICMETER'"></cammentermanage>
          <cawatermanage v-else></cawatermanage>
        </template>
      </div>
    </div>

    <!--详情弹窗-->
    <el-dialog
      :title="detailTit"
      :visible.sync="detailDio"
      width="795px"
      :class="[
        'detailDio',
        dtype + deviceType,
        { 'DkbInnerDialog DkbDeviceCenter': isDkbDeviceCenter }
      ]"
      :append-to-body="isDkbDeviceCenter"
    >
      <div
        :class="['contDio', { 'viewBox DkbScroll': isDkbDeviceCenter }]"
        v-if="deviceType == '1' && dtype == 'detail'"
      >
        <div class="tit_dio">
          <div class="flexItem">设备名称：{{ wareInfo.device_name }}</div>
          <div class="flexItem">设备ID：{{ wareInfo.device_no_id }}</div>
          <div class="flexItem">箱格数量：{{ wareInfo.total }}</div>
        </div>
        <div
          class="freshBtn"
          v-if="isActive == 'FRESSBOX' && !isDkbDeviceCenter"
        >
          <template v-if="wareInfo.online == true">
            <el-button type="warning" size="mini" @click="batchSetDevice('1')"
              >开箱</el-button
            >
            <el-button type="warning" size="mini" @click="batchSetDevice('2')"
              >释放</el-button
            >
            <el-button type="warning" size="mini" @click="batchSetDevice('3')"
              >禁用</el-button
            >
          </template>
          <template v-else>
            <el-button type="info" size="mini" disabled>开箱</el-button>
            <el-button type="info" size="mini" disabled>释放</el-button>
            <el-button type="info" size="mini" disabled>禁用</el-button>
          </template>
        </div>
        <div class="list_dio">
          <el-checkbox-group v-model="check_box">
            <el-row :gutter="19">
              <el-col :span="colNumber" v-for="(item, index) in boxList" :key="index">
                <div class="colItem" v-if="!isDkbDeviceCenter">
                  <el-checkbox
                    class="box_check"
                    :label="item.box_number"
                    v-if="isActive == 'FRESSBOX' && wareInfo.online == true"
                  ></el-checkbox>
                  <div class="name">
                    <img v-show="item.box_state == 2" src="static/images/zhuanyong.png" class="iconOccupy" alt="">
                    <template>{{ item.box_number }}</template>
                    <template v-if="item.box_size == 'A'">(极大)</template>
                    <template v-if="item.box_size == 'B'">(大)</template>
                    <template v-if="item.box_size == 'C'">(中)</template>
                    <template v-if="item.box_size == 'D'">(小)</template>
                    <template v-if="item.box_size == 'E'">(极小)</template>
                  </div>
                  <div v-if="settingTag != 1" class="tip1">
                    <span v-if="item.status == '0'">空闲中</span>
                    <!-- <template v-if="isActive == 'FRESSBOX'">
                    <span v-if="item.status=='1' && item.order_status == 'W'" class="isIng">使用中</span>
                    <span v-if="item.status=='1' && item.order_status == 'V'" class="isIng">已预约</span>
                  </template>
                  <template v-else> -->
                    <span v-if="item.status == '1'" class="isIng">使用中</span>
                    <!-- </template> -->
                    <span v-if="item.status == '2'" class="isNo">已禁用</span>
                    <span v-if="item.status == '3'" class="isBook">已预约</span>
                  </div>
                  <div v-else class="tip1">
                    <div style="display: inline-block; color: #606266" class="">
                      <span>名称: </span>
                      <span v-if="item.box_name != ''">{{
                        item.box_name
                      }}</span>
                      <span v-else>未设置</span>
                    </div>
                    <div style="display: inline-block; color: #606266">
                      <span>状态: </span>
                      <span v-if="item.status == '0'">空闲中</span>
                      <span v-if="item.status == '1'" class="isIng"
                        >使用中</span
                      >
                      <span v-if="item.status == '2'" class="isNo">已禁用</span>
                      <span v-if="item.status == '3'" class="isBook"
                        >已预约</span
                      >
                    </div>
                  </div>

                  <div
                    style="margin-bottom: 10px; height: 40px"
                    v-if="isActive == 'MAGICCUBE' && settingTag == 1"
                    class="tip1"
                  >
                    <el-tag
                      v-if="item.box_tag.length <= 0"
                      class="boxTag"
                      size="mini"
                    ></el-tag>
                    <el-tag
                      size="mini"
                      class="boxTagItem"
                      v-for="(tagItem, index) in item.box_tag"
                      :key="index"
                      :title="tagItem"
                      >{{ tagItem }}</el-tag
                    >
                  </div>
                  <div class="tip2">
                    <span v-if="item.openStatus == 'off'">已关闭</span>
                    <span v-if="item.openStatus == 'on'" class="isOpen"
                      >已打开</span
                    >
                  </div>
                  <div class="btn" v-loading="item.isLoading">
                    <em
                      class="noBtn"
                      v-if="item.status == '2' || wareInfo.online == false"
                      >打开</em
                    >
                    <em v-else @click="boxControl(index)">打开</em>
                  </div>
                </div>
                <div class="colItem" v-else>
                  <p
                    :class="[
                      'status',
                      item.status == '1'
                        ? 'isIng'
                        : item.status == '2'
                        ? 'isNo'
                        : ''
                    ]"
                  >
                    {{
                      item.status == "1"
                        ? "使用中"
                        : item.status == "2"
                        ? "已禁用"
                        : "空闲中"
                    }}
                  </p>
                  <p class="des">
                    <span class="num">{{ item.box_number }}号</span>
                    <span class="size">
                      ({{
                        item.box_size == "A"
                          ? "极大"
                          : item.box_size == "B"
                          ? "大"
                          : item.box_size == "C"
                          ? "中"
                          : item.box_size == "D"
                          ? "小"
                          : item.box_size == "E"
                          ? "极小"
                          : ""
                      }})
                    </span>
                    <span
                      :class="[
                        'openStatus',
                        { isOpen: item.openStatus == 'on' }
                      ]"
                      >{{
                        item.openStatus == "off" ? "已关闭" : "已打开"
                      }}</span
                    >
                  </p>
                  <div
                    :class="[
                      'btn',
                      { no: item.status == '2' || wareInfo.online == false }
                    ]"
                    v-loading="item.isLoading"
                  >
                    <em
                      class="noBtn"
                      v-if="item.status == '2' || wareInfo.online == false"
                      >打开</em
                    >
                    <em v-else @click="boxControl(index)">打开</em>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-checkbox-group>
          <div class="paging" v-if="total > page">
            <el-pagination
              background
              @current-change="CurrentChange"
              :current-page.sync="curr"
              :page-size="page"
              layout="prev, pager, next"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <!-- 水电表，温湿度采集器 -->
      <div
        class="contDio"
        v-if="deviceType == '3'"
        v-loading="detailDioLoading"
        element-loading-background="rgba(240, 243, 248, 0.7)"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
      >
        <div class="meterList">
          <div class="meterStatus">
            <div class="item_meter">
              <span>设备名称：</span>
              <p>{{ wareInfo.device_name }}</p>
            </div>
            <div class="item_meter">
              <span>设备ID：</span>
              <p>{{ wareInfo.device_no_id }}</p>
            </div>
            <div class="item_meter">
              <span>当前状态：</span>
              <p v-if="wareInfo.online == true">在线</p>
              <p v-else>离线</p>
            </div>
            <template v-if="this.isActive == 'EPSENSOR'">
              <div class="item_meter">
                <span>当前温度：</span>
                <p>{{ wareInfo.temperature }}℃</p>
              </div>
              <div class="item_meter">
                <span>当前读湿度：</span>
                <p>{{ wareInfo.humiture }}RH%</p>
              </div>
              <div class="item_meter">
                <span>当前气体浓度：</span>
                <p>{{ wareInfo.smoke }}ppm</p>
              </div>
            </template>
            <div class="item_meter" v-else>
              <span>当前读数：</span>
              <p>{{ wareInfo.deviceEmeter }}{{ wareInfo.unit }}</p>
            </div>
          </div>
          <div class="echartsDiv">
            <div class="time">
              <el-radio-group
                v-model="EPSENSORDetail.date_type"
                size="mini"
                @change="getTempHumiByDate()"
                v-if="this.isActive == 'EPSENSOR'"
              >
                <el-radio label="day" border>天</el-radio>
                <el-radio label="week" border>周</el-radio>
                <el-radio label="month" border>月</el-radio>
              </el-radio-group>
              <el-radio-group
                v-model="timeType"
                size="mini"
                @change="getEmeterYearMonthDay(wareInfo.index)"
                v-else
              >
                <el-radio label="DAY" border>日</el-radio>
                <el-radio label="MONTH" border>月</el-radio>
                <el-radio label="YEAR" border>年</el-radio>
              </el-radio-group>
            </div>
            <div class="echart" id="echartDetail"></div>
            <div class="markArea">
              <span
                class="mark"
                v-for="(item, index) in wareInfo.markArr"
                :key="index"
                >{{ item }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div
        :class="['contDio', { tableWrapper: isDkbDeviceCenter }]"
        v-if="
          deviceType == '2' && (isActive == 'ACCESS' || isActive == 'FEIBIFACE')
        "
      >
        <div class="tit_dio">
          <div class="flexItem">设备名称：{{ wareInfo.device_name }}</div>
          <div class="flexItem">设备ID：{{ wareInfo.device_no_id }}</div>
          <div class="item_meter">
            状态：<span v-if="wareInfo.online == true">在线</span
            ><span v-else>离线</span>
          </div>
        </div>
        <el-table style="width:100%;" :data="accessList">
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column label="操作人" prop="user_name"></el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">
              <span v-if="scope.row.open_type == 'OPEN_KEY'">远程开门</span>
              <span v-else-if="scope.row.open_type == 'SHARE_OPEN_KEY'"
                >权限分享</span
              >
              <span
                v-else-if="
                  scope.row.open_type == 'SCANNED_OPEN' ||
                    scope.row.open_type == 'SCAN_OPEN'
                "
                >扫码开门</span
              >
              <span v-else-if="scope.row.open_type == 'CARD_OPEN'"
                >刷卡开门</span
              >
              <span v-else-if="scope.row.open_type == 'FACE_OPEN'"
                >人脸开门</span
              >
              <span v-else>按钮开门</span>
            </template>
          </el-table-column>
          <el-table-column label="开门时间" prop="open_time"></el-table-column>
        </el-table>
        <div class="paging" v-if="total2 > page2">
          <el-pagination
            :class="[{ dkbPagination: isDkbDeviceCenter }]"
            :background="!isDkbDeviceCenter"
            @current-change="CurrentChange2"
            :current-page.sync="curr2"
            :page-size="page2"
            layout="prev, pager, next"
            :total="total2"
          >
          </el-pagination>
        </div>
      </div>
      <div
        class="contDio"
        v-if="
          deviceType == '1' && isActive == 'SAFEEXPRESS' && dtype == 'address'
        "
      >
        <CDeviceMap
          :device_no_id="wareInfo.device_no_id"
          @getActiveInfo="getActiveInfo"
        ></CDeviceMap>
      </div>
      <!-- 魔方柜箱格二维码列表 -->
      <div
        :class="['contDio', { 'tableWrapper boxCodeList': isDkbDeviceCenter }]"
        v-if="
          deviceType == '1' && isActive == 'MAGICCUBE' && dtype == 'codeList'
        "
        v-loading="codeLoding"
        element-loading-background="rgba(240, 243, 248, 0.7)"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
      >
        <div class="tit_dio">
          <div class="flexItem">设备名称：{{ wareInfo.device_name }}</div>
          <div class="flexItem">设备ID：{{ wareInfo.device_no_id }}</div>
          <div class="flexItem">箱格数量：{{ wareInfo.total }}</div>
        </div>
        <div class="explain">
          <iframe
            class="iframe hide"
            id="allBoxCode"
            marginwidth="0"
            marginheight="0"
            :srcdoc="allSrcdoc"
          ></iframe>
          <el-button type="primary" @click="printAllBoxCode"
            >全部打印</el-button
          >
          <p class="text">
            此二维码用于设备箱格开门，授权用户扫描后可立即进行开门操作
          </p>
        </div>
        <el-table style="width:100%;" :data="boxList">
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column label="箱格号" prop="box_number"></el-table-column>
          <el-table-column label="二维码">
            <template slot-scope="scope">
              <el-button type="text" @click="previewBoxCode(scope.row.url)"
                >查看</el-button
              >
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <!-- <iframe style="display:none" id="boxCode" :srcdoc="'<img src=&quot;' + scope.row.url + '&quot;>'"></iframe> -->
              <iframe
                class="iframe hide"
                id="boxCode"
                marginwidth="0"
                marginheight="0"
                :srcdoc="srcdoc"
              ></iframe>
              <el-button type="text" @click="printBoxCode(scope.row)"
                >打印</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="paging" v-if="total > page">
          <el-pagination
            background
            @current-change="CurrentChange"
            :current-page.sync="curr"
            :page-size="page"
            layout="prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>

    <!-- 设置 -->
    <el-dialog :title="detailTit" :visible.sync="showBoxTagPage" width="795px">
      <el-row :gutter="20">
        <el-col :span="4">箱格号</el-col>
        <el-col :span="4">箱格名称</el-col>
        <el-col :span="4">标签1</el-col>
        <el-col :span="4">标签2</el-col>
        <el-col :span="4">标签3</el-col>
        <el-col :span="4">标签4</el-col>
      </el-row>
      <el-form>
        <el-row :gutter="20" v-for="(item, index) in boxTagList" :key="index">
          <el-col :span="4">
            <span class="tagSettingBox">{{ item.box_number }}号</span>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-input v-model="item.box_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-input v-model="item.box_tag[0]"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-input v-model="item.box_tag[1]"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-input v-model="item.box_tag[2]"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-input v-model="item.box_tag[3]"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        class="paging"
        v-if="boxPaginationParam.total > boxPaginationParam.page"
      >
        <el-pagination
          background
          @current-change="boxChange"
          :current-page.sync="boxPaginationParam.curr"
          :page-size="boxPaginationParam.page"
          layout="prev, pager, next"
          :total="boxPaginationParam.total"
        >
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmBoxNameTag()">保存</el-button>
      </div>
    </el-dialog>
    <!--查看二维码弹窗-->
    <el-dialog
      title=""
      :visible.sync="previewDio"
      width="350px"
      :class="[
        'previewDio',
        { 'DkbInnerDialog DkbDeviceCenter qrCodeBox': isDkbDeviceCenter }
      ]"
      :append-to-body="isDkbDeviceCenter"
    >
      <div class="tr" v-if="isActive == 'ACCESS'">
        <el-button v-print="'#ewm'">打印</el-button>
      </div>
      <div class="img" id="ewm"><img :src="dioImageUrl" alt="" /></div>
      <!-- <div class="img" id="ewm">测试打印</div> -->
      <div class="tips">
        此二维码用于{{
          isActive == "ACCESS" ? "门禁" : "设备箱格"
        }}开门，授权用户<br />扫描后可立即进行开门操作
      </div>
    </el-dialog>

    <!--智能售卖柜-设置-->
    <el-dialog title="设置" :visible.sync="SELLBOXSettingDio" width="500px">
      <el-form
        class="SELLBOXSettForm"
        ref="SELLBOXSettForm"
        :model="SELLBOXSettForm"
        label-width="120px"
      >
        <el-form-item label="最大上架时间：">
          <el-input
            class="input"
            type="number"
            v-model="SELLBOXSettForm.max_on_time"
          ></el-input>
          <span class="unit">小时</span>
        </el-form-item>
        <p class="hint">
          设置允许卖家上架商品的最大时间超过最大值未上架商品则失效
        </p>
        <el-form-item label="最大预定时间：">
          <el-input
            class="input"
            type="number"
            v-model="SELLBOXSettForm.max_book_time"
          ></el-input>
          <span class="unit">小时</span>
        </el-form-item>
        <p class="hint">
          设置允许买家预定商品的最大时间超过最大值系统将自动取消商品预约
        </p>
        <el-form-item label="箱格容积：">
          <el-input
            class="input"
            type="number"
            v-model="SELLBOXSettForm.max_cell_product_count"
          ></el-input>
          <span class="unit">个</span>
        </el-form-item>
        <p class="hint">设置设备每个箱格允许存放的最大商品数</p>
        <el-form-item label="微信分账比例：">
          <el-input
            class="input"
            type="number"
            v-model="SELLBOXSettForm.wechat_profit_sharing_percent"
          ></el-input>
          <span class="unit">%</span>
        </el-form-item>
        <p class="hint">设置微信分账平台获利的最大百分比</p>
        <el-form-item>
          <el-button type="primary" @click="setDeviceConfig">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 车位锁-授权及操作记录 -->
    <el-dialog
      :title="detailTit"
      :visible.sync="recordDio"
      :width="(recordType === 'authRecord' ? 900 : 790) + 'px'"
      class="detailDio recordDio"
    >
      <div class="contDio">
        <div class="tit_dio">
          <div class="flexItem">设备名称：{{ wareInfo.device_name }}</div>
          <div class="flexItem">设备ID：{{ wareInfo.device_no_id }}</div>
          <!-- <div class="flexItem">状态：{{wareInfo.status}}</div> -->
        </div>
        <div class="search_dio">
          <el-input
            class="text"
            v-model="recordPaging.user_name"
            placeholder="请输入操作人姓名"
            clearable
          ></el-input>
          <el-input
            class="text"
            v-model="recordPaging.user_string"
            placeholder="请输入授权人姓名或手机号码"
            clearable
            v-if="recordType === 'authRecord'"
          ></el-input>
          <el-date-picker
            class="dateText"
            v-model="recordPaging.timeRange"
            type="datetimerange"
            unlink-panels
            range-separator="至"
            start-placeholder="开始操作日期"
            end-placeholder="结束操作日期"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
          >
          </el-date-picker>
          <el-button
            type="primary"
            class="serchBtn"
            @click="getDeviceRecords('search')"
            >搜索</el-button
          >
        </div>
      </div>
      <el-table :data="recordList" v-if="recordType === 'authRecord'">
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column
          label="操作人"
          prop="share_user_name"
        ></el-table-column>
        <el-table-column label="授权人" prop="user_name"></el-table-column>
        <el-table-column label="授权手机号码" prop="phone_no"></el-table-column>
        <el-table-column label="授权时间" prop="time"></el-table-column>
        <el-table-column label="操作时间" prop="create_time"></el-table-column>
      </el-table>
      <el-table :data="recordList" v-else>
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="操作人" prop="edit_name"></el-table-column>
        <el-table-column label="操作内容" prop="content"></el-table-column>
        <el-table-column label="操作时间" prop="time"></el-table-column>
      </el-table>
      <div class="paging" v-if="recordPaging.count > recordPaging.perPage">
        <el-pagination
          @current-change="recordCurrentChange"
          :current-page.sync="recordPaging.page"
          :page-size="recordPaging.perPage"
          layout="prev, pager, next"
          :total="recordPaging.count"
        >
        </el-pagination>
      </div>
    </el-dialog>

    <!-- 温湿度采集器-预警情况 -->
    <el-dialog
      title="预警情况"
      :visible.sync="EPSENSORWarningDio"
      width="795px"
      :class="[
        'detailDio EPSENSORWarningDio',
        { 'DkbInnerDialog DkbDeviceCenter': isDkbDeviceCenter }
      ]"
      :append-to-body="isDkbDeviceCenter"
    >
      <div :class="['contDio']">
        <div class="search_dio flexStart">
          <el-input
            class="text"
            v-model="EPSENSORWarningPaging.device_no_id"
            placeholder="请输入设备ID或设备名称"
            clearable
          ></el-input>
          <el-select
            class="text"
            v-model="EPSENSORWarningPaging.exception_type"
            placeholder="请选择预警类型"
            clearable
            @focus="getExceptionTypeList"
          >
            <el-option
              :label="item.name"
              :value="item.type"
              v-for="(item, index) in EPSENSORWarningTypeList"
              :key="index"
            ></el-option>
          </el-select>
          <el-button
            type="primary"
            class="serchBtn"
            @click="getExceptionList('search')"
            >搜索</el-button
          >
          <el-button class="btnSetting" @click="EPSENSORWarningSetDio = true"
            >预警设置</el-button
          >
        </div>
        <div
          class="tit_dio flexStart"
          v-if="
            TempHumiLimit.temperature_up_limit &&
              TempHumiLimit.temperature_up_limit !== ''
          "
        >
          <div class="flexItem">
            温度预警值：{{ TempHumiLimit.temperature_down_limit }}℃~{{
              TempHumiLimit.temperature_up_limit
            }}℃
          </div>
          <div class="flexItem">
            湿度预警值：{{ TempHumiLimit.humidity_down_limit }}RH%~{{
              TempHumiLimit.humidity_up_limit
            }}RH%
          </div>
        </div>
        <div class="tit_dio flexStart" v-else>
          <div class="flexItem">温度预警值：/</div>
          <div class="flexItem">湿度预警值：/</div>
        </div>
        <el-table class="DkbStripe" :data="EPSENSORWarningList">
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column label="设备ID" prop="device_no_id"></el-table-column>
          <el-table-column
            label="设备名称"
            prop="device_name"
          ></el-table-column>
          <el-table-column
            label="预警类型"
            prop="category_name"
          ></el-table-column>
          <el-table-column
            label="预警值"
            prop="exception_value"
          ></el-table-column>
          <el-table-column label="持续时间段" prop="duration"></el-table-column>
        </el-table>
        <div
          class="paging"
          v-if="EPSENSORWarningPaging.count > EPSENSORWarningPaging.perPage"
        >
          <el-pagination
            :class="[{ dkbPagination: isDkbDeviceCenter }]"
            @current-change="EPSENSORWarningChange"
            :current-page.sync="EPSENSORWarningPaging.page"
            :page-size="EPSENSORWarningPaging.perPage"
            layout="prev, pager, next"
            :total="EPSENSORWarningPaging.count"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- 温湿度采集器-预警情况-预警设置 -->
    <el-dialog
      title="预警设置"
      :visible.sync="EPSENSORWarningSetDio"
      width="350px"
      :class="[
        'detailDio settingDio EPSENSORsettingDio',
        { 'DkbInnerDialog DkbDeviceCenter': isDkbDeviceCenter }
      ]"
      :append-to-body="isDkbDeviceCenter"
    >
      <el-form :model="TempHumiLimitForm" label-width="100px">
        <div class="row T">
          <p class="rowTit">温度</p>
        </div>
        <div class="itemRow">
          <el-form-item label="预警值上限：">
            <el-input
              class="input"
              v-model="TempHumiLimitForm.temperature_up_limit"
              type="number"
              :min="TempHumiLimitForm.temperature_down_limit"
            >
              <template slot="append">℃</template>
            </el-input>
          </el-form-item>
          <el-form-item label="预警值下限：">
            <el-input
              class="input"
              v-model="TempHumiLimitForm.temperature_down_limit"
              type="number"
              min="1"
              :max="TempHumiLimitForm.temperature_up_limit"
            >
              <template slot="append">℃</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="row H">
          <p class="rowTit">湿度</p>
        </div>
        <div class="itemRow">
          <el-form-item label="预警值上限：">
            <el-input
              class="input"
              v-model="TempHumiLimitForm.humidity_up_limit"
              type="number"
              :min="TempHumiLimitForm.humidity_down_limit"
            >
              <template slot="append">RH%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="预警值下限：">
            <el-input
              class="input"
              v-model="TempHumiLimitForm.humidity_down_limit"
              type="number"
              min="1"
              :max="TempHumiLimitForm.humidity_up_limit"
            >
              <template slot="append">RH%</template>
            </el-input>
          </el-form-item>
        </div>
        <el-form-item class="btnRow">
          <el-button>取消</el-button>
          <el-button type="primary" @click="setTempHumiLimit">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 消毒一体机-设置模式 -->
    <el-dialog
      title="设置模式"
      :visible.sync="THAIOSetDio"
      width="350px"
      :class="[
        'detailDio THAIOSetDio',
        { 'DkbInnerDialog DkbDeviceCenter': isDkbDeviceCenter }
      ]"
      :append-to-body="isDkbDeviceCenter"
    >
      <div class="btnArea">
        <p
          :class="['btn', { active: item.is_set }]"
          v-for="(item, index) in THAIOModeList"
          :key="index"
          @click="setThAioRunMode(index, item.value, item.is_set)"
        >
          {{ item.name }}
        </p>
        <!-- <el-button class="active">加湿模式</el-button>
        <el-button>除湿模式</el-button>
        <el-button>自动模式</el-button>
        <el-button>通风模式</el-button> -->
      </div>
    </el-dialog>
    <!-- 消毒一体机-操作记录 -->
    <el-dialog
      title="操作记录"
      :visible.sync="THAIORecordDio"
      width="795px"
      :class="[
        'detailDio THAIORecordDio',
        { 'DkbInnerDialog DkbDeviceCenter': isDkbDeviceCenter }
      ]"
      :append-to-body="isDkbDeviceCenter"
    >
      <div class="search_dio flexStart">
        <el-input
          class="text"
          v-model="THAIORecordPaging.device_no_id"
          placeholder="请输入设备ID或设备名称"
          clearable
        ></el-input>
        <el-date-picker
          class="text dateText datePicker"
          v-model="THAIORecordPaging.timeRange"
          type="datetimerange"
          unlink-panels
          range-separator="至"
          start-placeholder="开始操作日期"
          end-placeholder="结束操作日期"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
        >
        </el-date-picker>
        <el-button
          type="primary"
          class="serchBtn"
          @click="getOperateList('search')"
          >搜索</el-button
        >
      </div>
      <el-button type="primary" class="exportBtn" @click="exportOperateList"
        >导出</el-button
      >
      <el-table class="DkbStripe" id="THAIORecordList" :data="THAIORecordList">
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="设备ID" prop="device_no_id"></el-table-column>
        <el-table-column label="设备名称" prop="device_name"></el-table-column>
        <el-table-column label="操作内容" prop="content"></el-table-column>
        <el-table-column
          label="操作时间"
          prop="operator_time"
        ></el-table-column>
      </el-table>
      <div
        class="paging"
        v-if="THAIORecordPaging.count > THAIORecordPaging.perPage"
      >
        <el-pagination
          :class="[{ dkbPagination: isDkbDeviceCenter }]"
          @current-change="THAIORecordChange"
          :current-page.sync="THAIORecordPaging.page"
          :page-size="THAIORecordPaging.perPage"
          layout="prev, pager, next"
          :total="THAIORecordPaging.count"
        >
        </el-pagination>
      </div>
    </el-dialog>

    <!-- 漏水传感器-配置线路 -->
    <el-dialog
      title="配置线路"
      :visible.sync="WATERLEAKAGECofDio"
      width="420px"
      :class="[
        'detailDio WATERLEAKAGECofDio',
        { 'DkbInnerDialog DkbDeviceCenter': isDkbDeviceCenter }
      ]"
      :append-to-body="isDkbDeviceCenter"
    >
      <el-form class="innerForm" label-width="80px">
        <el-form-item
          :label="'线路' + index + '：'"
          v-for="(item, index) in WATERLEAKAGECofForm"
          :key="index"
        >
          <div class="inputBox">
            <el-input
              class="inputDeposit"
              v-model="WATERLEAKAGECofForm[index]"
              clearable
            ></el-input>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="btn btn-confirm"
          type="primary"
          @click="setWaterleakageRoad"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <!-- 密码保险柜弹窗 -->
    <el-dialog
      :title="Secrecyform.Title"
      :width="Secrecyform.Width"
      :append-to-body="isDkbDeviceCenter"
      :visible.sync="Secrecyform.secrecyDio"
      :class="[
        'detailDio secrecyDio',
        { 'DkbInnerDialog DkbDeviceCenter': isDkbDeviceCenter }
      ]"
      @close="closeSecrecyDio"
    >
      <div
        class="contDio tableWrapper"
        v-if="Secrecyform.Type == 'early' || Secrecyform.Type == 'open'"
      >
        <div class="searchDio search_dio">
          <el-input
            class="w200"
            v-model="Secrecyform.Keyword"
            placeholder="请输入设备ID或设备名称"
            @keyup.enter.native="SecrecySearchFun"
          ></el-input>
          <el-button type="primary" @click="SecrecySearchFun">搜索</el-button>
        </div>
        <el-table :data="Secrecyform.TableData" style="width:100%">
          <el-table-column
            type="index"
            label="序号"
            width="80"
          ></el-table-column>
          <el-table-column label="设备ID" prop="DeviceNoId"></el-table-column>
          <el-table-column label="设备名称" prop="DeviceName"></el-table-column>
          <el-table-column
            label="预警类型"
            prop="CategoryName"
            v-if="Secrecyform.Type == 'early'"
          ></el-table-column>
          <el-table-column
            label="报警时间"
            prop="CreateTime"
            v-if="Secrecyform.Type == 'early'"
          ></el-table-column>
          <el-table-column
            label="开门时间"
            prop="CreateTime"
            v-if="Secrecyform.Type == 'open'"
          ></el-table-column>
        </el-table>
        <div class="paging" v-if="Secrecyform.total > Secrecyform.limits">
          <el-pagination
            @current-change="SecrecyChangeCurr"
            :current-page.sync="Secrecyform.curr"
            :page-size="Secrecyform.limits"
            layout="prev, pager, next, jumper"
            :total="Secrecyform.total"
          >
          </el-pagination>
        </div>
      </div>
      <template v-else-if="Secrecyform.Type == 'setting'">
        <div class="contDio">
          <el-form
            :model="Secrecyform"
            label-width="130px"
            class="SELLBOXSettForm"
          >
            <el-form-item label="密码有效周期：">
              <el-input
                v-model="Secrecyform.Validity"
                class="w100 mr10"
              ></el-input>
              <span class="unit">天</span>
            </el-form-item>
            <p class="hint col9">
              设置保密柜密码有效时间，0代表永久有效周期<br />超过有效时间密码自动失效，需要后台手动修改密码
            </p>
            <el-form-item label="密码容错最大值：">
              <el-input
                v-model="Secrecyform.ErrorNum"
                class="w100 mr10"
              ></el-input>
              <span class="unit">次</span>
            </el-form-item>
            <p class="hint col9">
              设置允许输错密码的次数<br />超过最大值平板将自动冻结，需要管理员去到现场进行解冻
            </p>
          </el-form>
        </div>
        <span slot="footer">
          <el-button type="primary" @click="UpdateDeivcePasswordInfo"
            >确认</el-button
          >
        </span>
      </template>
      <template v-else>
        <div class="step">
          <div class="item" :class="{ activeStep: Secrecyform.Step == 1 }">
            1、验证身份
          </div>
          <div class="item" :class="{ activeStep: Secrecyform.Step == 2 }">
            2、修改第一段密码
          </div>
          <div class="item" :class="{ activeStep: Secrecyform.Step == 3 }">
            3、修改第二段密码
          </div>
        </div>
        <div class="contdio">
          <el-form
            :model="Secrecyform"
            label-position="top"
            class="Secrecyform"
          >
            <el-input style="position:fixed;bottom:-9999px"></el-input>
            <el-input
              type="password"
              style="position:fixed;bottom:-9999px"
            ></el-input>
            <template v-if="Secrecyform.Step == 1">
              <el-form-item label="请输入管理员账号：">
                <el-input
                  v-model="Secrecyform.UserAccount"
                  placeholder="请输入管理员账号"
                ></el-input>
              </el-form-item>
              <el-form-item label="请输入管理员密码：">
                <el-input
                  v-model="Secrecyform.Password"
                  type="password"
                  placeholder="请输入管理员密码"
                ></el-input>
              </el-form-item>
            </template>

            <template v-else-if="Secrecyform.Step == 2">
              <el-form-item label="请设置第一段密码：">
                <el-input
                  v-model="Secrecyform.PasswordOne"
                  type="password"
                  placeholder="大小写字母、数字、下划线组合"
                ></el-input>
              </el-form-item>
              <el-form-item label="请重复输入第一段密码：">
                <el-input
                  v-model="Secrecyform.ConfirmOne"
                  type="password"
                  placeholder="验证两次输入的密码是否一致"
                ></el-input>
              </el-form-item>
            </template>

            <template v-else-if="Secrecyform.Step == 3">
              <el-form-item label="请设置第二段密码：">
                <el-input
                  v-model="Secrecyform.PasswordTwo"
                  type="password"
                  placeholder="大小写字母、数字、下划线组合"
                ></el-input>
              </el-form-item>
              <el-form-item label="请重复输入第二段密码：">
                <el-input
                  v-model="Secrecyform.ConfirmTwo"
                  type="password"
                  placeholder="验证两次输入的密码是否一致"
                ></el-input>
              </el-form-item>
            </template>
          </el-form>
        </div>
        <span slot="footer">
          <el-button @click="closeSecrecyDio" v-if="Secrecyform.Step == 1"
            >取消</el-button
          >
          <el-button v-else @click="SecrecyPrevStep">上一步</el-button>
          <el-button
            type="primary"
            v-if="Secrecyform.Step != 3"
            @click="SecrecyNextStep"
            >下一步</el-button
          >
          <el-button type="primary" v-else @click="UpdateDeivcePassword"
            >确认</el-button
          >
        </span>
      </template>
    </el-dialog>

    <!-- 云视频-实时预览 -->
    <el-dialog
      title="实时预览"
      :visible.sync="VIDEOCLOUDDio"
      width="600px"
      :class="[
        'detailDio VIDEOCLOUDDio',
        { 'DkbInnerDialog DkbDeviceCenter': isDkbDeviceCenter }
      ]"
      :append-to-body="isDkbDeviceCenter"
    >
      <div v-loading="VIDEOCLOUDDioLoading">
        <p class="hint" v-if="VIDEOCLOUDDioLoad_status === 'error'">
          视频加载失败，请<sapn class="refresh" @click="VIDEOCLOUDLoad"
            >刷新</sapn
          >重试
        </p>
        <video
          class="video"
          ref="VIDEOCLOUD"
          x5-playsinline="true"
          playsinline="true"
          webkit-playsinline="true"
          x-webkit-airplay="allow"
          preload="true"
          muted
          controls
        ></video>
      </div>
    </el-dialog>

    <!-- <iframe class="iframe" id="boxCode00" :srcdoc="srcdoc"></iframe>
    <el-button type="text" @click="printBoxCode00()">打印</el-button> -->
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import {
  showToast,
  localUserInfo,
  setDeviceIcon,
  updataBreadCrumb,
  deepCopy
} from "../../../../static/js/utility/utility.js";
import { userApi, deviceApi } from "../../../../static/js/api.js";
import cammentermanage from "../CEnergyManage/CAmmeterManage";
import cawatermanage from "../CWaterManage/CAwaterManage";
import CDeviceMap from "./CDeviceMap.vue";
let Hls = require("hls.js");

let vm;
export default {
  name: "CDeviceComponent",
  components: {
    swiper,
    swiperSlide,
    cammentermanage,
    CDeviceMap,
    cawatermanage
  },

  props: {
    isDkbDeviceCenter: Boolean
  },

  data() {
    return {
      //设置标签(针对魔方柜), 需要开启的话设置为 1
      isTest: 0,
      settingTag: 1,
      colNumber: 4,
      showBoxTagPage: false,
      boxTagList: [],
      boxPaginationParam: {
        curr: 1,
        page: 10,
        total: 0,
      },
      tabActive: "1",

      space_id: [], //空间id
      zhList: [], // 智慧空间和智慧供应链（数据看板使用）

      pageCount: 0,
      zhkjList: [], //智慧空间

      pageCount2: 0,
      zhgylList: [], //智慧供应链

      pageCount3: 0,
      thirdList: [], // 第三方平台

      isActive: "",

      swiperOption: {
        navigation: {
          nextEl: ".el-icon-caret-left",
          prevEl: ".el-icon-caret-right"
        },

        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true
        },

        observer: true
      },

      deviceList: [], //设备列表

      widthNum: 64,

      isEcharts: false, //电表显示总览/详情

      detailTit: "",
      deviceType: "",
      detailDio: false, // 详情弹窗
      detailDioLoading: false, // 详情弹窗加载
      //柜体详情箱格分页
      curr: 1, //当前页
      page: 12, //显示个数
      total: 20, //总数据

      check_box: [],

      dioLoading: false, //箱格列表loading

      accessList: [],
      //门禁详情箱格分页
      curr2: 1, //当前页
      page2: 10, //显示个数
      total2: 10, //总数据

      timeType: "DAY",
      wareInfo: {
        index: 0,
        device_no_id: "",
        device_name: "",
        online: false,
        deviceEmeter: "",
        total: 0
      },

      boxList: [],
      isLoading: false,

      previewDio: false, //预览二维码
      dioImageUrl: "", //二维码地址

      dtype: "", // 对话框显示类型

      codeLoding: false,
      srcdoc: "", //单个箱格二维码内容
      allSrcdoc: "", //全部箱格二维码内容
      // 箱格二维码打印样式
      codeBoxStyle:
        "margin:0; width:100%; height:100vh; text-align:center; display:flex; flex-direction:column; align-items:center; justify-content:center;page-break-after:avoid;",
      codeBoxTextStyle: "font-size:30px; font-weight:bold;",

      // 智能售卖柜设置
      SELLBOXSettingDio: false,
      SELLBOXSettForm: {},

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        }
      },

      // 车位锁授权及操作记录
      recordDio: false,
      recordType: "",
      recordList: [],
      recordPaging: {
        page: 1,
        perPage: 10,
        count: 0,
        user_name: "",
        timeRange: [], // 时间范围
        user_string: "" // 手机号或授权人姓名
      },

      // 温湿度传感器-预警情况
      EPSENSORWarningDio: false,
      EPSENSORWarningList: [],
      EPSENSORWarningTypeList: [], //预警类型列表
      EPSENSORWarningPaging: {
        page: 1,
        perPage: 10,
        device_no_id: "",
        exception_type: ""
      },

      // 温湿度传感器-预警情况-预警设置
      EPSENSORWarningSetDio: false,
      TempHumiLimit: {},
      //预警值
      TempHumiLimitForm: {},

      // 温湿度采集器-详情
      EPSENSORDetail: {
        date_type: "day"
      },

      // 消毒一体机-操作记录
      THAIORecordDio: false,
      THAIORecordPaging: {
        page: 1,
        perPage: 10,
        device_no_id: "",
        timeRange: []
      },

      THAIORecordList: [],
      // 消毒一体机-设置模式
      THAIOSetDio: false,
      THAIOModeList: [],

      // 漏水传感器
      WATERLEAKAGECofDio: false,
      WATERLEAKAGECofForm: [],

      // 云视频
      hls: null,
      VIDEOCLOUDDioLoading: false,
      VIDEOCLOUDDio: false,
      VIDEOCLOUDDioLoad_status: "", // 视频是否加载成功，success成功，error失败
      VIDEOCLOUDSrc: "", // 当前访问云视频地址

      isToggleShow: "1", // 设备列表显示方式，1：卡片，2：表格

      //搜索
      deviceKeyword: {
        device_no: "", //设备名称或者设备ID
        address: "" //设备地址
      },

      //设备列表table分页
      tableCurr: 1, //当前页
      tablePage: 10, //显示个数
      tableTotal: 0, //总数据

      //密码保险柜
      Secrecyform: {
        Title: "",
        Width: "800px",
        Type: "",
        secrecyDio: false,
        Keyword: "", //搜索信息
        TableData: [], //列表数据
        Validity: "90", //密码有效期
        ErrorNum: "3", //密码容错次数

        device_no_id: "",
        Token: "", //管理员的token
        Step: 1, //步骤
        UserAccount: "", //管理员账号
        Password: "", //管理员密码
        PasswordOne: "",
        ConfirmOne: "",
        PasswordTwo: "",
        ConfirmTwo: "",

        //分页
        curr: 1,
        limits: 10,
        total: 0
      },

      tabNum: 0,

      // isShowDetail: !['ACCESS', 'FEIBIFACE', 'INVENTORYROBOT', 'NODOORWAREHOUSE', 'MULTIWAREHOUSE', 'WAREHOUSE', 'SOCKET', 'CPL', 'WATERLEAKAGE', 'THAIO', 'SECRECY', 'VIDEOCLOUD'].includes(isActive),
    };
  },

  //定义这个sweiper对象
  computed: {},

  created() {
    vm = this;
    let bWidth = document.body.clientWidth;
    if (bWidth > 1600) {
      vm.tabNum = 7;
    } else if (bWidth <= 1600 && bWidth > 1200) {
      vm.tabNum = 5;
    } else {
      vm.tabNum = 3;
    }
    // this.space_id = this.$store.state.spaceID
    if (this.isDkbDeviceCenter) {
      this.tablePage = 9; //设置数据看板表格显示的条数
      this.getEquipmentAllTypeList();
    }
  },

  mounted() {},

  methods: {
    // 打开实时浏览弹窗
    openVIDEOCLOUDDio(index, item) {
      vm.VIDEOCLOUDDio = true;
      vm.VIDEOCLOUDDioLoad_status = "";
      vm.VIDEOCLOUDSrc = item.video_url.m3u8;
      setTimeout(() => {
        vm.VIDEOCLOUDLoad();
      },
 500);
    },

    // 直播视频加载
    VIDEOCLOUDLoad() {
      vm.VIDEOCLOUDDioLoading = true;
      vm.VIDEOCLOUDDioLoad_status = "";
      let source = vm.VIDEOCLOUDSrc;
      let ref_VIDEOCLOUDE = vm.$refs.VIDEOCLOUD;
      if (Hls.isSupported()) {
        vm.hls = new Hls();
        vm.hls.loadSource(source);
        vm.hls.attachMedia(ref_VIDEOCLOUDE);

        vm.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          console.log("加载成功");
          vm.VIDEOCLOUDDioLoading = false;
          vm.VIDEOCLOUDDioLoad_status = "success";
          ref_VIDEOCLOUDE.play();
        });
        vm.hls.on(Hls.Events.ERROR, (event, data) => {
          // 监听出错事件
          vm.VIDEOCLOUDDioLoading = false;
          vm.VIDEOCLOUDDioLoad_status = "error";
          // vm.VIDEOCLOUDDioLoad_statusText = data.response.code === 400 ? '连线失败' : ''
          // showToast('加载失败')
          console.log("加载失败");
          console.log(event, data);
        });
      } else if (ref_VIDEOCLOUDE.canPlayType("application/vnd.apple.mpegurl")) {
        ref_VIDEOCLOUDE.src = source;
        ref_VIDEOCLOUDE.addEventListener("loadedmetadata", function() {
          ref_VIDEOCLOUDE.play();
        });
      }
    },

    // 直播视频停止观看
    VIDEOCLOUDPause() {
      let ref_VIDEOCLOUDE = vm.$refs.VIDEOCLOUD;
      ref_VIDEOCLOUDE.pause();
      vm.hls.destroy();
      vm.hls = null;
    },

    //密码保险柜搜索
    SecrecySearchFun() {
      if (vm.Secrecyform.Type == "early") {
        vm.ExceptionList(1);
      } else {
        vm.OpenLogList(1);
      }
    },

    //密码保险柜预警记录
    async ExceptionList(curr, limits) {
      let data = {
        Keyword: vm.Secrecyform.Keyword,
        Curr: curr ? curr : vm.Secrecyform.curr,
        Limits: limits ? limits : vm.Secrecyform.limits
      };
      const res = await deviceApi.ExceptionList(data);
      if (res.ErrCode == 0) {
        vm.Secrecyform.TableData = res.Result.List;
        vm.Secrecyform.total = parseInt(res.Result.Total);
      } else {
        showToast(res.ErrMsg);
      }
    },

    //密码保险柜开门记录
    async OpenLogList(curr, limits) {
      let data = {
        Keyword: vm.Secrecyform.Keyword,
        Curr: curr ? curr : vm.Secrecyform.curr,
        Limits: limits ? limits : vm.Secrecyform.limits
      };
      const res = await deviceApi.OpenLogList(data);
      if (res.ErrCode == 0) {
        vm.Secrecyform.TableData = res.Result.List;
        vm.Secrecyform.total = parseInt(res.Result.Total);
      } else {
        showToast(res.ErrMsg);
      }
    },

    //修改密码保险柜密码
    async UpdateDeivcePassword() {
      let rePass = new RegExp(/^[\w]{6,20}$/);
      if (vm.Secrecyform.PasswordTwo == "") {
        showToast("请输入第二段密码");
        return;
      } else if (!rePass.test(vm.Secrecyform.PasswordTwo)) {
        showToast("请填写6-20位字母、数字和下划线组合的密码");
        return;
      } else if (vm.Secrecyform.ConfirmTwo == "") {
        showToast("请输入验证密码");
        return;
      } else if (vm.Secrecyform.PasswordTwo !== vm.Secrecyform.ConfirmTwo) {
        showToast("密码验证错误，请重新输入");
        return;
      }
      const data = {
        Token: vm.Secrecyform.Token,
        FirstPassowrd: vm.Secrecyform.PasswordOne,
        SecondPassowrd: vm.Secrecyform.PasswordTwo,
        DeviceNoId: vm.Secrecyform.device_no_id
      };
      const res = await deviceApi.UpdateDeivcePassword(data);
      if (res.ErrCode == 0) {
        showToast("修改成功！");
        vm.closeSecrecyDio();
        vm.getEquipmentDeviceList(vm.isActive);
      } else {
        showToast(res.ErrMsg);
      }
    },

    //检查设备管理员账号
    async CheckDeviceAccount() {
      let reUser = new RegExp(/^[0-9a-zA-Z]{6,15}$/);
      let rePass = new RegExp(/^[\w]{6,20}$/);
      if (vm.Secrecyform.UserAccount == "") {
        showToast("请输入管理员账号");
        return;
      } else if (!reUser.test(vm.Secrecyform.UserAccount)) {
        showToast("请填写6-15位字母和数字组合的账号");
        return;
      }
      if (vm.Secrecyform.Password == "") {
        showToast("请输入管理员密码");
        return;
      } else if (!rePass.test(vm.Secrecyform.Password)) {
        showToast("请填写6-20位字母、数字和下划线组合的密码");
        return;
      }
      const data = {
        UserAccount: vm.Secrecyform.UserAccount,
        Password: vm.Secrecyform.Password,
        DeviceNoId: vm.Secrecyform.device_no_id
      };
      const res = await deviceApi.CheckDeviceAccount(data);
      if (res.ErrCode == 0) {
        vm.Secrecyform.Step = 2;
        vm.Secrecyform.Token = res.Result.Token;
      } else {
        showToast(res.ErrMsg);
      }
    },

    //设置密码过期信息
    async UpdateDeivcePasswordInfo() {
      if (vm.Secrecyform.Validity == "") {
        showToast("请输入密码有效周期");
        return;
      }
      if (vm.Secrecyform.ErrorNum == "") {
        showToast("请输入密码容错次数");
        return;
      }
      const data = {
        Validity: vm.Secrecyform.Validity,
        Count: vm.Secrecyform.ErrorNum
      };
      const res = await deviceApi.UpdateDeivcePasswordInfo(data);
      if (res.ErrCode == 0) {
        showToast("设置成功！");
        vm.closeSecrecyDio();
        vm.getEquipmentDeviceList(vm.isActive);
      } else {
        showToast(res.ErrMsg);
      }
    },

    //密码保险柜上一步
    SecrecyPrevStep() {
      if (vm.Secrecyform.Step == 2) {
        vm.Secrecyform.Token = "";
        vm.Secrecyform.UserAccount = "";
        vm.Secrecyform.Password = "";
        vm.Secrecyform.PasswordOne = "";
        vm.Secrecyform.ConfirmOne = "";
        vm.Secrecyform.PasswordTwo = "";
        vm.Secrecyform.ConfirmTwo = "";
        vm.Secrecyform.Step = 1;
      } else if (vm.Secrecyform.Step == 3) {
        vm.Secrecyform.PasswordOne = "";
        vm.Secrecyform.ConfirmOne = "";
        vm.Secrecyform.PasswordTwo = "";
        vm.Secrecyform.ConfirmTwo = "";
        vm.Secrecyform.Step = 2;
      }
    },

    //密码保险柜下一步
    SecrecyNextStep() {
      if (vm.Secrecyform.Step == 1) {
        vm.CheckDeviceAccount();
      } else {
        let rePass = new RegExp(/^[\w]{6,20}$/);
        if (vm.Secrecyform.PasswordOne == "") {
          showToast("请输入第一段密码");
          return;
        } else if (!rePass.test(vm.Secrecyform.PasswordOne)) {
          showToast("请填写6-20位字母、数字和下划线组合的密码");
          return;
        } else if (vm.Secrecyform.ConfirmOne == "") {
          showToast("请输入验证密码");
          return;
        } else if (vm.Secrecyform.PasswordOne !== vm.Secrecyform.ConfirmOne) {
          showToast("密码验证错误，请重新输入");
          return;
        }
        vm.Secrecyform.Step = 3;
      }
    },

    //打开密码保险柜弹窗
    openSecrecyDio(type, info) {
      vm.Secrecyform.Type = type;
      if (type == "early") {
        vm.Secrecyform.Title = "预警记录";
        vm.ExceptionList();
      } else if (type == "open") {
        vm.Secrecyform.Title = "开门记录";
        vm.OpenLogList();
      } else if (type == "setting") {
        vm.Secrecyform.Title = "设置";
        vm.Secrecyform.Width = "500px";
      } else if (type == "edit") {
        vm.Secrecyform.Title = "修改密码";
        vm.Secrecyform.Width = "600px";
        vm.Secrecyform.device_no_id = info.device_no_id;
      }
      vm.Secrecyform.secrecyDio = true;
    },

    //关闭密码保险柜弹窗
    closeSecrecyDio() {
      vm.Secrecyform = {
        Title: "",
        Width: "800px",
        Type: "",
        secrecyDio: false,
        Keyword: "", //搜索信息
        TableData: [], //列表数据
        Validity: "90", //密码有效期
        ErrorNum: "3", //密码容错次数
        device_no_id: "",
        Token: "",
        Step: 1, //步骤
        UserAccount: "", //管理员账号
        Password: "", //管理员密码
        PasswordOne: "",
        ConfirmOne: "",
        PasswordTwo: "",
        ConfirmTwo: "",
        //分页
        curr: 1,
        limits: 10,
        total: 0
      };
    },

    //密码保险柜弹窗切换当前页
    SecrecyChangeCurr(val) {
      vm.Secrecyform.curr = val;
      if (vm.Secrecyform.Type == "early") {
        vm.ExceptionList(val);
      } else if (vm.Secrecyform.Type == "open") {
        vm.OpenLogList(val);
      }
    },

    //批量操作箱格
    async batchSetDevice(type) {
      let that = this;
      if (that.check_box == "") {
        showToast("请先选择箱格");
        return;
      }
      const data = {
        boxs: that.check_box,
        device_no_id: that.wareInfo.device_no_id,
        type: type // 1开门、2释放、3禁用、4启用箱格
      };
      const res = await deviceApi.batchSetDevice(data);
      if (res.meta.code == 200) {
        that.getDeviceBoxList(that.wareInfo.index, that.curr, that.page);
        that.check_box = [];
        showToast("操作成功");
      } else {
        showToast(res.meta.message);
      }
    },

    //改变查看设备列表方式
    toggleChangeList() {
      this.tableCurr = 1;
      this.getEquipmentDeviceList(this.isActive);
    },

    //每页显示条数
    tableSizeChange(val) {
      this.tablePage = val;
      this.tableCurr = 1;
      this.getEquipmentDeviceList(this.isActive);
    },

    //切换当前页
    tableCurrentChange(val) {
      this.tableCurr = val;
      this.getEquipmentDeviceList(this.isActive);
    },

    // 获取所有类型列表（空间和供应链）
    async getEquipmentAllTypeList() {
      let that = this;
      that.isLoading = true;
      let res = await deviceApi.getEquipmentAllTypeList();
      if (res.meta.code === 200) {
        // console.log('res', res)
        var arrList = res.data;
        for (var i = 0; i < arrList.length; i++) {
          arrList[i].icon = setDeviceIcon(arrList[i].code);
          if (arrList[i].category === "3") {
            arrList[i].icon = setDeviceIcon(arrList[i].type);
          }
        }

        var limits = 7; // 每页显示条数

        if (arrList != "") {
          that.isActive = arrList[0].code;
          that.getEquipmentDeviceList(that.isActive);
        } else {
          that.isActive = "";
          that.deviceList = [];
        }

        if (arrList != "") {
          that.pageCount = Math.ceil(arrList.length / vm.tabNum);
          var arr = [];
          for (var i = 0, j = arrList.length; i < j; i += vm.tabNum) {
            arr.push(arrList.slice(i, i + vm.tabNum));
          }
          that.zhList = arr;
        } else {
          that.zhList = [];
          that.pageCount = 0;
        }

        if (that.isActive != "ELECTRICMETER") {
          this.isEcharts = false;
        }
      } else {
        showToast(res.meta.message);
      }
    },

    // 保密柜-获取当前选中保密柜信息
    getActiveInfo(space_name) {
      this.detailTit = space_name;
    },

    // 查看二维码列表（魔方柜）
    previewImgList(index) {
      let vm = this;
      vm.detailDio = true;
    },

    // 查看箱格二维码
    previewBoxCode(url) {
      this.dioImageUrl = url;
      this.previewDio = true;
    },

    // 打印所有箱格二维码
    async printAllBoxCode(row) {
      let vm = this;
      let allSrcdoc = "",
        boxList;
      console.log("tag", vm.total, vm.page, vm.boxList);
      if (vm.total <= vm.page) {
        boxList = [...vm.boxList];
      } else {
        const dataObj = {
          page: 1,
          perPage: 99999,
          device_no_id: vm.wareInfo.device_no_id
        };
        vm.codeLoding = true;
        const res = await deviceApi.getDeviceBoxList(dataObj);
        vm.codeLoding = false;
        if (res.meta.code == 200) {
          boxList = [...res.data.list];
        } else {
          showToast(res.meta.message);
          return;
        }
      }
      boxList.forEach((item, index) => {
        allSrcdoc +=
          '<div class="codeBox" style="' +
          vm.codeBoxStyle +
          '">' +
          '<img class="code" src="' +
          item.url +
          '">' +
          '<p class="text" style="' +
          vm.codeBoxTextStyle +
          '">' +
          item.box_number +
          "号箱格</p></div>";
      });
      vm.allSrcdoc = allSrcdoc;
      setTimeout(() => {
        document.getElementById("allBoxCode").contentWindow.print();
      },
 100);
    },

    // 打印单个箱格二维码
    printBoxCode(row) {
      let vm = this;
      vm.srcdoc =
        '<div class="codeBox" style="' +
        vm.codeBoxStyle +
        '">' +
        '<img class="code" src="' +
        row.url +
        '">' +
        '<p class="text" style="' +
        vm.codeBoxTextStyle +
        '">' +
        row.box_number +
        "号箱格</p></div>";

      console.log("srcdoc", vm.srcdoc);
      setTimeout(() => {
        document.getElementById("boxCode").contentWindow.print();
      },
 100);
    },

    //查看门禁二维码
    async previewImg(index) {
      let that = this;
      let company_ic = localUserInfo.getItem().company_ic;
      const dataObj = {
        data: {
          page: "pages/login/login",
          scene: company_ic + "so" + that.deviceList[index].device_no_id
        },

        mode: "getUnlimited",
        type: "so",
        device_no_id: that.deviceList[index].device_no_id
      };
      const res = await deviceApi.previewImg(dataObj);
      if (res.meta.code === 200) {
        that.dioImageUrl = res.data.image_url;
        that.previewDio = true;
      } else {
        showToast(res.meta.message);
      }
    },

    // tab切换点击
    tabClick(tab, event) {
      let that = this;
      if (this.tabActive == "1") {
        if (that.zhkjList[0]) {
          that.isActive = that.zhkjList[0][0].code;
          that.getEquipmentDeviceList(this.isActive);
        } else {
          that.isActive = "";
          that.deviceList = [];
        }
      } else if (this.tabActive == "2") {
        if (that.zhgylList[0]) {
          that.isActive = that.zhgylList[0][0].code;
          that.getEquipmentDeviceList(that.isActive);
        } else {
          that.isActive = "";
          that.deviceList = [];
        }
      } else {
        if (that.thirdList[0]) {
          that.isActive = that.thirdList[0][0].code;
          that.getEquipmentDeviceList(that.isActive);
        } else {
          that.isActive = "";
          that.deviceList = [];
        }
      }
    },

    //询问箱格开关
    boxControl(index) {
      let that = this;
      this.$confirm("你确定要打开箱门？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          that.boxControlFun(index);
        })
        .catch(() => {});
    },

    //箱格开关
    async boxControlFun(index) {
      let that = this;
      that.boxList[index].isLoading = true;
      const dataObj = {
        type: "open",
        device_no_id: that.boxList[index].device_no_id,
        box_no: that.boxList[index].box_number
      };
      const res = await deviceApi.deviceControl(dataObj);
      if (res.meta.code == 200) {
        that.boxList[index].isLoading = false;
        if (res.data.result == true) {
          showToast("箱格打开成功");
          // that.$message.success('箱格打开成功')
        } else {
          showToast("箱格打开失败");
          // that.$message.error('箱格打开失败')
        }
        that.getDeviceBoxList(
          this.wareInfo.index,
          that.curr,
          that.page,
          "detail"
        );
      } else {
        showToast(res.meta.message);
        // that.$message.error(res.meta.message)
      }
    },

    //设备开关询问
    deviceControl(index) {
      let that = this;
      let cfTitle = "";
      if (that.deviceList[index].type == "1") {
        cfTitle = "你确定要重启？";
      } else if (
        that.deviceList[index].type == "2" &&
        that.isActive == "ACCESS"
      ) {
        cfTitle = "你确定要开门？";
      } else if (
        that.isActive == "ELECTRICMETER" ||
        that.isActive == "SOCKET" ||
        that.isActive == "WATERMETER"
      ) {
        if (that.deviceList[index].isOpen == "2") {
          cfTitle = "你确定要关闭？";
        } else {
          cfTitle = "你确定要开启？";
        }
      } else {
        cfTitle =
          that.deviceList[index].isOpen == "2"
            ? "你确定要开启？"
            : "你确定要关闭？";
      }
      this.$confirm(cfTitle, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          that.deviceControlFun(index);
        })
        .catch(() => {
          if (
            that.isActive == "ELECTRICMETER" ||
            that.isActive == "SOCKET" ||
            that.isActive == "WATERMETER"
          ) {
            if (that.deviceList[index].isOpen == "1") {
              that.deviceList[index].isOpen = "2";
            } else {
              that.deviceList[index].isOpen = "1";
            }
          }
        });
    },

    //设备开关
    async deviceControlFun(index) {
      let that = this;
      let switchType = "";
      if (that.deviceList[index].type == "1") {
        switchType = "reboot";
      } else {
        if (that.isActive == "ACCESS") {
          switchType = "open";
        } else if (
          that.isActive == "ELECTRICMETER" ||
          that.isActive == "SOCKET" ||
          that.isActive == "WATERMETER"
        ) {
          if (that.deviceList[index].isOpen == "1") {
            switchType = "open";
          } else {
            switchType = "close";
          }
        } else {
          if (that.deviceList[index].isOpen == "1") {
            switchType = "close";
          } else {
            switchType = "open";
          }
        }
      }
      that.isLoading = true;
      const dataObj = {
        type: switchType,
        device_no_id: that.deviceList[index].device_no_id
      };
      const res = await deviceApi.deviceControl(dataObj);
      that.isLoading = false;
      if (res.meta.code == 200) {
        if (res.data.result == true) {
          if (that.deviceList[index].type == "1") {
            showToast("重启成功！");
          }
          if (that.deviceList[index].type == "2" && that.isActive == "ACCESS") {
            showToast("打开成功！");
          }
          if (
            that.isActive == "ELECTRICMETER" ||
            that.isActive == "SOCKET" ||
            that.isActive == "WATERMETER"
          ) {
            if (that.deviceList[index].isOpen == "1") {
              showToast("已开启！");
            } else {
              showToast("已关闭！");
            }
          }
          if (that.isActive == "THAIO") {
            if (that.deviceList[index].isOpen == "1") {
              showToast("已关闭！");
            } else {
              showToast("已开启！");
            }
          }
          that.getEquipmentDeviceList(that.isActive);
        } else {
          if (that.deviceList[index].type == "1") {
            showToast("重启失败！");
          }
          if (that.deviceList[index].type == "2" && that.isActive == "ACCESS") {
            showToast("开门失败！");
          }
          if (
            that.isActive == "ELECTRICMETER" ||
            that.isActive == "SOCKET" ||
            that.isActive == "WATERMETER"
          ) {
            if (that.deviceList[index].isOpen == "1") {
              showToast("开启失败！");
              that.deviceList[index].isOpen = "2";
            } else {
              showToast("关闭失败！");
              that.deviceList[index].isOpen = "1";
            }
          }
          if (that.isActive == "THAIO") {
            if (that.deviceList[index].isOpen == "1") {
              showToast("关闭失败！");
            } else {
              showToast("开启失败！");
            }
          }
        }
      } else {
        if (
          that.isActive == "ELECTRICMETER" ||
          that.isActive == "SOCKET" ||
          that.isActive == "WATERMETER"
        ) {
          if (that.deviceList[index].isOpen == "1") {
            that.deviceList[index].isOpen = "2";
          } else {
            that.deviceList[index].isOpen = "1";
          }
        }
        showToast(res.meta.message);
      }
    },

    //获取箱格列表
    async getDeviceBoxList(index, curr, limits, type) {
      let that = this;
      if (!type) {
        // this.dioLoading = true
        that.isLoading = true;
      }
      let deviceNoId = that.deviceList[index].device_no_id
      const dataObj = {
        'page': curr ? curr : that.curr,
        'perPage': limits ? limits : that.page,
        'device_no_id': deviceNoId
      }
      //4.0
      const res = await deviceApi.getDeviceBoxList(dataObj)
      if (res.meta.code == 200) {
        //4.0s
        let res2 = await deviceApi.getBoxMesList({ cabinet_id: deviceNoId })

        for (let i in res.data.list) {
          // console.log(i)
          if (res2 && res2.meta.code == 200) {
            for (let body of res2.body) {
              if (body.box_no == res.data.list[i].box_number) {
                res.data.list[i].box_state = body.box_state
              }
            }
          }
          res.data.list[i].isLoading = false
        }

        that.total = parseInt(res.data.total)
        that.wareInfo.total = parseInt(res.data.total)
        that.boxList = res.data.list
        if (!type) {
          // that.dioLoading = false
          that.isLoading = false
          that.detailDio = true
        }
      } else {
        // that.dioLoading = false
        that.isLoading = false
        showToast(res.meta.message)
        // that.$message.error(res.meta.message)
      }
    },

    //分页
    CurrentChange(val) {
      this.curr = val;
      this.getDeviceBoxList(this.wareInfo.index, val, this.page, "detail");
    },

    CurrentChange2(val) {
      this.curr2 = val;
      this.deviceRecord(this.wareInfo.index, val, this.page2);
    },

    //打开详情
    openDetail(index, dtype) {
      let that = this;
      that.dtype = dtype;
      that.deviceType = that.deviceList[index].type;
      that.wareInfo.index = index;
      that.wareInfo.device_no_id = that.deviceList[index].device_no_id;
      that.wareInfo.device_name = that.deviceList[index].device_name;
      that.wareInfo.online = that.deviceList[index].online;
      // 魔方柜
      if (that.isActive == "MAGICCUBE" && that.settingTag == 1) {
        that.colNumber = 8;
      }
      if (this.deviceList[index].type == "1" && dtype == "detail") {
        that.detailTit = "查看箱格";
        that.curr = 1;
        that.total = 0;
        that.page = 12;
        that.getDeviceBoxList(this.wareInfo.index, that.curr, that.page);
      }
      if (
        this.deviceList[index].type == "2" &&
        (this.isActive == "ACCESS" || this.isActive == "FEIBIFACE")
      ) {
        that.detailTit = "开门记录";
        that.curr2 = 1;
        that.total2 = 0;
        that.deviceRecord(index);
      }
      if (
        this.deviceList[index].type == "3" &&
        this.isActive == "ELECTRICMETER"
      ) {
        that.detailTit = "查看电表数据";
        that.getEmeterYearMonthDay(index);
      }
      if (this.deviceList[index].type == "3" && this.isActive == "WATERMETER") {
        that.detailTit = "查看水表数据";
        that.getEmeterYearMonthDay(index);
      }
      if (
        this.deviceList[index].type == "1" &&
        this.isActive == "SAFEEXPRESS" &&
        dtype == "address"
      ) {
        that.detailDio = true;
      }
      if (
        this.deviceList[index].type == "1" &&
        this.isActive == "MAGICCUBE" &&
        dtype == "codeList"
      ) {
        that.detailTit = "查看箱格二维码";
        that.curr = 1;
        that.page = 10;
        that.getDeviceBoxList(this.wareInfo.index, that.curr, that.page);
      }
      if (
        this.isActive == "CPL" &&
        (dtype == "authRecord" || dtype == "operateRecord")
      ) {
        // 车位锁操作/授权记录
        that.recordType = dtype;
        that.detailTit = dtype == "authRecord" ? "授权记录" : "操作记录";
        that.recordPaging.page = 1;
        that.recordPaging.count = 0;
        that.getDeviceRecords();
      }
      if (this.isActive == "WATERLEAKAGE" && dtype === "WATERLEAKAGECofDio") {
        // 漏水传感器-配置线路
        that.getWaterleakageRoad();
      }
      if (this.isActive == "THAIO" && dtype === "THAIOSetDio") {
        // 消毒一体机-设置模式
        that.THAIOModeList = that.deviceList[index].run_mode;
        that.THAIOSetDio = true;
      }
      if (this.deviceList[index].type == "3" && this.isActive == "EPSENSOR") {
        // 温度传感器-详情
        that.detailTit = "详情";
        that.getTempHumiByDate();
        // wareInfo
      }
    },

    //获取开门记录
    async deviceRecord(index, curr, limits) {
      let that = this;
      // this.dioLoading = true
      that.isLoading = true;
      const dataObj = {
        device_no_id: that.deviceList[index].device_no_id,
        page: curr ? curr : that.curr2,
        perPage: limits ? limits : that.page2
      };
      const res = await deviceApi.deviceRecord(dataObj);
      if (res.meta.code == 200) {
        that.accessList = res.data.list;
        that.total2 = parseInt(res.data.count);
        // that.dioLoading = false
        that.isLoading = false;
        that.detailDio = true;
      } else {
        // that.dioLoading = false
        that.isLoading = false;
        showToast(res.meta.message);
        // that.$message.error(res.meta.message)
      }
    },

    // 分页
    recordCurrentChange(val) {
      this.recordPaging.page = val;
      this.getDeviceRecords();
    },

    // 获取设备记录（授权、操作）
    getDeviceRecords(search) {
      let way =
        this.recordType === "authRecord"
          ? "getDeviceAuthRecords"
          : "getDeviceOpenRecords";
      if (search) {
        this[way]("search");
      } else {
        this[way]();
      }
    },

    // 获取设备授权记录
    async getDeviceAuthRecords(search) {
      let vm = this;
      let index = vm.wareInfo.index;
      vm.recordList = [];
      let hasRange = vm.recordPaging.timeRange.length !== 0;
      let data = {
        device_no_id: vm.deviceList[index].device_no_id,
        page: vm.recordPaging.page,
        perPage: vm.recordPaging.perPage,
        user_name: vm.recordPaging.user_name,
        user_string: vm.recordPaging.user_string,
        start_time: hasRange ? vm.recordPaging.timeRange[0] : "",
        end_time: hasRange ? vm.recordPaging.timeRange[1] : ""
      };
      if (search) {
        data.page = 1;
      }
      console.log("授权记录data", data);
      let res = await deviceApi.getDeviceAuthRecords(data);
      if (res.meta.code === 200) {
        vm.recordDio = true;
        vm.recordList = res.data.list;
      } else {
        showToast(res.meta.message);
      }
    },

    // 获取设备操作记录
    async getDeviceOpenRecords(search) {
      let vm = this;
      let index = vm.wareInfo.index;
      vm.recordList = [];
      let hasRange = vm.recordPaging.timeRange.length !== 0;
      let data = {
        device_no_id: vm.deviceList[index].device_no_id,
        page: vm.recordPaging.page,
        perPage: vm.recordPaging.perPage,
        user_name: vm.recordPaging.user_name,
        start_time: hasRange ? vm.recordPaging.timeRange[0] : "",
        end_time: hasRange ? vm.recordPaging.timeRange[1] : ""
      };
      if (search) {
        data.page = 1;
      }
      console.log("操作记录data", data);

      let res = await deviceApi.getDeviceOpenRecords(data);
      if (res.meta.code === 200) {
        vm.recordDio = true;
        vm.recordList = res.data.list;
        vm.recordPaging.count = Number(res.data.count);
      } else {
        showToast(res.meta.message);
      }
    },

    // 水电表-获取电/水表读数
    async getEmeterYearMonthDay(index) {
      let that = this;
      let loadingType = "";
      if (that.detailDio) {
        loadingType = "detailDioLoading";
      } else {
        loadingType = "isLoading";
      }
      this[loadingType] = true;
      const dataObj = {
        dateType: that.timeType,
        device_no_id: that.deviceList[index].device_no_id
      };
      let res = await deviceApi.getEmeterYearMonthDay(dataObj);
      this[loadingType] = false;
      if (res.meta.code == "200") {
        that.wareInfo.deviceEmeter = res.data.deviceEmeter;
        let xAxisData = [],
          yAxisData = [],
          trendName = "",
          unit = that.isActive == "ELECTRICMETER" ? "KWH" : "T", // 图表单位
          astr = that.isActive == "ELECTRICMETER" ? "用电量" : "用水量";

        for (let i in res.data.list) {
          let str =
            that.timeType == "YEAR"
              ? "月"
              : that.timeType == "MONTH"
              ? "日"
              : "时";
          str = i + str;
          let bstr =
            that.timeType == "YEAR"
              ? "本年"
              : that.timeType == "MONTH"
              ? "本月"
              : "今日";
          trendName = bstr + astr;
          xAxisData.push(str);
          yAxisData.push(res.data.list[i]);
        }

        that.detailDio = true;
        that.wareInfo.unit = unit;
        that.wareInfo.markArr = [astr];
        that.drawLine({ unit, trendName, xAxisData, yAxisData });
      } else {
        // this[loadingType] = false
        showToast(res.meta.message);
        // that.$message.error(res.meta.message)
      }
    },

    // 水电表-电表详情
    drawLine(params) {
      let that = this;
      let { unit, trendName, xAxisData, yAxisData } = params;
      this.$nextTick(function() {
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(
          document.getElementById("echartDetail")
        );
        // 绘制图表
        let option = {
          title: {
            left: "2%",
            text: trendName
          },

          xAxis: {
            type: "category",
            data: xAxisData
          },

          yAxis: {
            type: "value",
            name: unit
          },

          series: [
            {
              data: yAxisData,
              type: "line",
              lineStyle: {
                color: "#40d6e7"
              },

              itemStyle: {
                normal: {
                  borderWidth: 0,
                  label: {
                    show: true,
                    color: "#04cdf4"
                  }
                }
              }
            }
          ]
        };

        let htmlFontSize = this.$store.state.htmlFontSize;
        let option2 = {
          grid: {
            top: (100 / 100) * htmlFontSize,
            bottom: (30 / 100) * htmlFontSize,
            left: (40 / 100) * htmlFontSize,
            right: (110 / 100) * htmlFontSize,
            containLabel: true
          },

          title: {
            text: trendName,
            left: (27 / 100) * htmlFontSize,
            top: (25 / 100) * htmlFontSize,
            textStyle: {
              color: "#04cdf4",
              fontSize: (16 / 100) * htmlFontSize
            }
          },

          xAxis: {
            type: "category",
            data: xAxisData,
            axisLabel: {
              color: "#ffffff"
            },

            // 坐标轴
            axisLine: {
              onZero: false,
              lineStyle: {
                color: "#3a4a65" // 坐标轴颜色
              }
            },

            axisTick: {
              lineStyle: {
                width: (2 / 100) * htmlFontSize,
                color: "#576d91"
              }
            }
          },

          yAxis: {
            type: "value",
            name: unit,
            nameTextStyle: {
              color: "#04cdf4"
            },

            axisLabel: {
              color: "#ffffff"
            },

            // 坐标轴
            axisLine: {
              onZero: false,
              lineStyle: {
                color: "#3a4a65" // 坐标轴颜色
              }
            }
          },

          series: [
            {
              data: yAxisData,
              type: "line",
              lineStyle: {
                color: "#40d6e7"
              },

              itemStyle: {
                normal: {
                  borderWidth: 0,
                  label: {
                    show: true,
                    color: "#04cdf4"
                  }
                }
              }
            }
          ]
        };
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(that.isDkbDeviceCenter ? option2 : option);
      });
    },

    // 通过设备类型获取设备列表
    async getEquipmentDeviceList(code) {
      let that = this;
      this.deviceList = [];
      const data = {
        page: that.isToggleShow == "1" ? 1 : that.tableCurr,
        perPage: that.isToggleShow == "1" ? 99999 : that.tablePage,
        space_id: that.space_id.join(","),
        code: code,
        device_no: that.isToggleShow == "2" ? that.deviceKeyword.device_no : "",
        address: that.isToggleShow == "2" ? that.deviceKeyword.address : ""
      };
      that.isLoading = true;
      const res = await deviceApi.getEquipmentDeviceList(data);
      that.isLoading = false;
      if (res.meta.code == 200) {
        for (let i in res.data.list) {
          if (res.data.list[i].openStatus == "on") {
            res.data.list[i].isOpen = "1";
          } else {
            res.data.list[i].isOpen = "2";
          }
        }
        that.deviceList = res.data.list;
        that.tableTotal = parseInt(res.data.total);
      } else {
        showToast(res.meta.message);
        // that.$message.error(res.meta.message)
      }
    },

    // 业务单选
    changeActive(code, type) {
      this.isActive = code;
      this.tableCurr = 1;
      this.getEquipmentDeviceList(code);
      if (code != "ELECTRICMETER") {
        this.isEcharts = false;
      }
    },

    //获取列表
    async getEquipment() {
      let that = this;
      let dataObj = {
        space_id: that.space_id.join(",")
      };
      const res = await deviceApi.getEquipment(dataObj);
      if (res.meta.code == 200) {
        var arrList = res.data.ZHKJ;
        var arrList2 = res.data.ZHGYL;
        var arrList3 = res.data.THIRDTERRACE;

        var limits = 6; //每页显示条数
        if (arrList != "") {
          that.isActive = arrList[0].code;
          that.tabActive = "1";
          that.getEquipmentDeviceList(that.isActive);
        } else if (arrList2 != "" && arrList == "") {
          that.isActive = arrList2[0].code;
          that.tabActive = "2";
          that.getEquipmentDeviceList(that.isActive);
        } else if (arrList3 != "" && arrList == "" && arrList2 == "") {
          that.isActive = arrList3[0].code;
          that.tabActive = "3";
          that.getEquipmentDeviceList(that.isActive);
        } else {
          that.isActive = "";
          that.tabActive = "1";
          that.deviceList = [];
        }

        // 智慧空间
        if (arrList != "" && arrList != undefined) {
          for (var i = 0; i < arrList.length; i++) {
            // 设置icon
            arrList[i].icon = setDeviceIcon(arrList[i].code);
          }
          that.pageCount = Math.ceil(arrList.length / vm.tabNum);
          var arr = [];
          for (var i = 0, j = arrList.length; i < j; i += vm.tabNum) {
            arr.push(arrList.slice(i, i + vm.tabNum));
          }
          that.zhkjList = arr;
        } else {
          that.zhkjList = [];
          that.pageCount = 0;
        }
        console.log("zhkjList", that.zhkjList);
        console.log("pageCount", that.pageCount);

        // 智慧供应链
        if (arrList2 != "" && arrList2 != undefined) {
          for (var i = 0; i < arrList2.length; i++) {
            // 设置icon
            arrList2[i].icon = setDeviceIcon(arrList2[i].code);
          }
          that.pageCount2 = Math.ceil(arrList2.length / vm.tabNum);
          var arr2 = [];
          for (var i = 0, j = arrList2.length; i < j; i += vm.tabNum) {
            arr2.push(arrList2.slice(i, i + vm.tabNum));
          }
          that.zhgylList = arr2;
        } else {
          that.zhgylList = [];
          that.pageCount2 = 0;
        }

        // 第三方应用
        // console.log('arr3', arrList3)
        if (arrList3 != "" && arrList3 != undefined) {
          for (var i = 0; i < arrList3.length; i++) {
            // 设置icon
            arrList3[i].icon = setDeviceIcon(arrList3[i].type);
          }
          that.pageCount3 = Math.ceil(arrList3.length / vm.tabNum);
          var arr3 = [];
          for (var i = 0, j = arrList3.length; i < j; i += vm.tabNum) {
            arr3.push(arrList3.slice(i, i + vm.tabNum));
          }
          that.thirdList = arr3;
        } else {
          that.thirdList = [];
          that.pageCount3 = 0;
        }

        if (that.isActive != "ELECTRICMETER") {
          this.isEcharts = false;
        }
      } else {
        showToast(res.meta.message);
      }
    },

    // 智能售卖柜-获取设备配置的信息
    async getDeviceConfig() {
      let vm = this;
      vm.SELLBOXSettingDio = true;
      let data = {
        device_code: "SELLBOX"
      };

      let res = await deviceApi.getDeviceConfig(data);
      if (res.meta.code === 200) {
        console.log("res", res);
        vm.SELLBOXSettForm = res.data;
      } else {
        showToast(res.meta.message);
      }
    },

    // 智能售卖柜-设置设备配置的信息
    async setDeviceConfig() {
      let vm = this;
      let data = vm.SELLBOXSettForm;
      data.device_code = "SELLBOX";

      // 判断
      if (data.max_on_time == "") {
        showToast("请设置最大上架时间");
        return;
      }
      if (data.max_book_time == "") {
        showToast("请设置最大预定时间");
        return;
      }
      if (data.wechat_profit_sharing_percent == "") {
        showToast("请设置微信分账比例");
        return;
      }

      let res = await deviceApi.setDeviceConfig(data);
      if (res.meta.code === 200) {
        console.log("res", res);
        showToast("设置成功");
        vm.SELLBOXSettingDio = false;
      } else {
        showToast(res.meta.message);
      }
    },

    // 消毒一体机-获取设备操作记录
    getTHAIORecord() {
      let vm = this;
      vm.THAIORecordDio = true;
      vm.getOperateList();
    },

    THAIORecordChange(val) {
      this.THAIORecordPaging.page = val;
      this.getOperateList();
    },

    // 获取设备操作记录
    async getOperateList(search) {
      let vm = this;
      let hasRange = vm.THAIORecordPaging.timeRange.length !== 0;
      let data = {
        code: vm.isActive,
        page: vm.THAIORecordPaging.page,
        perPage: vm.THAIORecordPaging.perPage,
        device_no_id: vm.THAIORecordPaging.device_no_id,
        start_time: hasRange ? vm.THAIORecordPaging.timeRange[0] : "",
        end_time: hasRange ? vm.THAIORecordPaging.timeRange[1] : ""
      };
      if (search) {
        data.page = 1;
      }

      let res = await deviceApi.getOperateList(data);
      if (res.meta.code === 200) {
        vm.THAIORecordList = res.data.list;
        vm.THAIORecordPaging.count = Number(res.data.count);
      } else {
        showToast(res.meta.message);
      }
    },

    // 消毒一体机-导出操作记录
    async exportOperateList() {
      let vm = this;
      let data = {
        code: vm.isActive,
        device_no_id: vm.THAIORecordPaging.device_no_id
      };
      if (vm.THAIORecordPaging.timeRange.length !== 0) {
        data.start_time = vm.THAIORecordPaging.timeRange[0];
        data.end_time = vm.THAIORecordPaging.timeRange[1];
      }

      let res = await deviceApi.exportOperateList(data);
      if (res.meta.code === 200) {
        window.location.href = res.data.fileUrl;
      } else {
        showToast(res.meta.message);
      }
    },

    // 消毒一体机-设置模式
    async setThAioRunMode(mIndex, mode, is_set) {
      let vm = this;
      let data = {
        code: vm.isActive,
        device_no_id: vm.wareInfo.device_no_id,
        mode
      };

      let res = await deviceApi.setThAioRunMode(data);
      if (res.meta.code === 200) {
        vm.deviceList[vm.wareInfo.index].run_mode.forEach((item, index) => {
          vm.deviceList[vm.wareInfo.index].run_mode[index].is_set = false;
        });
        vm.deviceList[vm.wareInfo.index].run_mode[mIndex].is_set = true;
      } else {
        showToast(res.meta.message);
      }
    },

    // 漏水传感器-获取配置线路
    async getWaterleakageRoad() {
      let vm = this;
      let data = {
        device_no_id: vm.wareInfo.device_no_id
      };

      let res = await deviceApi.getWaterleakageRoad(data);
      if (res.meta.code === 200) {
        vm.WATERLEAKAGECofDio = true;
        vm.WATERLEAKAGECofForm = res.data;
      } else {
        showToast(res.meta.message);
      }
    },

    // 漏水传感器-设置配置线路
    async setWaterleakageRoad() {
      let vm = this;
      let road = [];
      for (let i in vm.WATERLEAKAGECofForm) {
        road.push(vm.WATERLEAKAGECofForm[i]);
      }
      let data = {
        device_no_id: vm.wareInfo.device_no_id,
        road
      };

      let res = await deviceApi.setWaterleakageRoad(data);
      if (res.meta.code === 200) {
        showToast("设置成功");
        vm.WATERLEAKAGECofDio = false;
      } else {
        showToast(res.meta.message);
      }
    },

    // 温湿度传感器-显示预警情况弹窗
    getEPSENSORWarning() {
      let vm = this;
      vm.EPSENSORWarningDio = true;
      vm.EPSENSORWarningPaging.page = 1;
      vm.EPSENSORWarningPaging.count = 0;
      vm.getExceptionList();
      vm.getTempHumiLimit();
    },

    // 分页
    EPSENSORWarningChange(val) {
      this.EPSENSORWarningPaging.page = val;
      this.getExceptionList();
    },

    // 温度传感器-获取预警记录
    async getExceptionList(search) {
      let vm = this;
      let data = {
        page: vm.EPSENSORWarningPaging.page,
        perPage: vm.EPSENSORWarningPaging.perPage,
        device_no_id: vm.EPSENSORWarningPaging.device_no_id,
        exception_type: vm.EPSENSORWarningPaging.exception_type
      };
      if (search) {
        data.page = 1;
      }

      let res = await deviceApi.getExceptionList(data);
      if (res.meta.code === 200) {
        vm.EPSENSORWarningList = res.data.list;
        vm.EPSENSORWarningPaging.count = Number(res.data.count);
      } else {
        showToast(res.meta.message);
      }
    },

    // 温度传感器-获取预警类型
    async getExceptionTypeList() {
      let vm = this;
      let res = await deviceApi.getExceptionTypeList();
      if (res.meta.code === 200) {
        vm.EPSENSORWarningTypeList = res.data.list;
      } else {
        showToast(res.meta.message);
      }
    },

    // 温度传感器-获取预警值
    async getTempHumiLimit() {
      let vm = this;
      let data = {
        code: vm.isActive
      };
      let res = await deviceApi.getTempHumiLimit(data);
      if (res.meta.code === 200) {
        vm.TempHumiLimit = res.data;
        vm.TempHumiLimitForm = deepCopy(res.data);
      } else {
        showToast(res.meta.message);
      }
    },

    // 温度传感器-设置预警值
    async setTempHumiLimit() {
      let vm = this;
      let data = vm.TempHumiLimitForm;
      data.code = vm.isActive;

      let res = await deviceApi.setTempHumiLimit(data);
      if (res.meta.code === 200) {
        showToast("设置成功");
        vm.EPSENSORWarningSetDio = false;
        vm.getTempHumiLimit();
      } else {
        showToast(res.meta.message);
      }
    },

    // 温度传感器-获取温湿度读数
    async getTempHumiByDate() {
      let vm = this;
      let data = {
        device_no_id: vm.wareInfo.device_no_id,
        date_type: vm.EPSENSORDetail.date_type
      };

      let res = await deviceApi.getTempHumiByDate(data);
      // if (res.meta.code === 200) {
      if (
        res.meta.code === 200 ||
        (res.meta.code === 1002 && res.data.list.length !== 0)
      ) {
        vm.wareInfo.temperature = res.data.current.temperature;
        vm.wareInfo.humiture = res.data.current.humiture;
        vm.wareInfo.smoke = res.data.current.smoke;
        vm.wareInfo.THList = res.data.list;
        vm.detailDio = true;
        vm.drawLine3();
      } else {
        showToast(res.meta.message);
      }
    },

    getLineData() {
      let list = [...this.wareInfo.THList];
      // let nowTimeType = vm.nowTimeType
      // let xInterval = nowTimeType === 1 ? 6 : nowTimeType === 2 ? 0 : 8
      let xData = [],
        TValArr = [],
        HValArr = [],
        SValArr = [];
      list.forEach(function(item, index) {
        xData.push(item.date);
        TValArr.push(item.temperature);
        HValArr.push(item.humiture);
        SValArr.push(item.smoke);
      });
      return { xData, TValArr, HValArr, SValArr };
    },

    drawLine3() {
      let that = this;
      let { xData, TValArr, HValArr, SValArr } = that.getLineData();
      console.log("that.getLineData()", that.getLineData());

      let getyAxis = function(unit, color) {
        let yAxis = {
          type: "value",
          name: unit,
          nameTextStyle: {
            color
          }
        };

        return yAxis;
      };
      let getseries = function(data, yAxisIndex, color) {
        let series = {
          data: data,
          type: "line",
          yAxisIndex: yAxisIndex,
          lineStyle: {
            color
          },

          itemStyle: {
            normal: {
              borderWidth: 0,
              label: {
                show: false
              }
            },

            emphasis: {
              borderWidth: 0,
              label: {
                show: true,
                color
              }
            }
          }
        };
        return series;
      };
      let yAxis = [],
        series = [],
        yAxisIndex = 0;
      if (that.wareInfo.temperature) {
        yAxis.push(getyAxis("℃/RH%", "#333333"));
        series.push(getseries(TValArr, yAxisIndex, "#40d6e7"));
        // yAxisIndex++
      }
      if (that.wareInfo.humiture) {
        if (yAxis.length === 0) {
          yAxis.push(getyAxis("℃/RH%", "#333333"));
        }
        series.push(getseries(HValArr, yAxisIndex, "#e99314"));
        yAxisIndex++;
      }
      if (that.wareInfo.smoke) {
        yAxis.push(getyAxis("ppm", "#749f83"));
        series.push(getseries(SValArr, yAxisIndex, "#749f83"));
      }

      this.$nextTick(function() {
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(
          document.getElementById("echartDetail")
        );
        // 绘制图表
        let option = {
          title: {
            left: "2%",
            text: ""
          },

          xAxis: {
            type: "category",
            data: xData,
            // 指示线
            axisPointer: {
              show: true,
              type: "line",
              lineStyle: {
                width: 1,
                type: "dashed",
                color: "#368bac"
              }
            }
          },

          yAxis,
          series
        };

        let htmlFontSize = this.$store.state.htmlFontSize;
        let option2 = {
          grid: {
            top: (100 / 100) * htmlFontSize,
            bottom: (30 / 100) * htmlFontSize,
            left: (40 / 100) * htmlFontSize,
            right: (110 / 100) * htmlFontSize,
            containLabel: true
          },

          xAxis: {
            type: "category",
            data: xData,
            axisLabel: {
              color: "#ffffff"
            },

            // 指示线
            axisPointer: {
              show: true,
              type: "line",
              lineStyle: {
                width: 1,
                type: "dashed",
                color: "#368bac"
              }
            },

            // 坐标轴
            axisLine: {
              onZero: false,
              lineStyle: {
                color: "#3a4a65" // 坐标轴颜色
              }
            },

            axisTick: {
              lineStyle: {
                width: (2 / 100) * htmlFontSize,
                color: "#576d91"
              }
            }
          },

          yAxis: [
            {
              type: "value",
              name: "℃/RH%",
              nameTextStyle: {
                color: "#ffffff"
              },

              axisLabel: {
                color: "#ffffff"
              },

              // 坐标轴
              axisLine: {
                onZero: false,
                lineStyle: {
                  color: "#3a4a65" // 坐标轴颜色
                }
              }
            },

            {
              type: "value",
              name: "ppm",
              nameTextStyle: {
                color: "#749f83"
              },

              axisLabel: {
                color: "#ffffff"
              },

              // 坐标轴
              axisLine: {
                onZero: false,
                lineStyle: {
                  color: "#749f83" // 坐标轴颜色
                }
              }
            }
          ],
          series: [
            {
              yAxisIndex: 0,
              data: TValArr,
              type: "line",
              lineStyle: {
                color: "#92bd37"
              },

              itemStyle: {
                normal: {
                  borderWidth: 0,
                  label: {
                    show: false
                  }
                },

                emphasis: {
                  borderWidth: 0,
                  label: {
                    show: true,
                    color: "#92bd37"
                  }
                }
              }
            },

            {
              yAxisIndex: 0,
              data: HValArr,
              type: "line",
              lineStyle: {
                color: "#e99314"
              },

              itemStyle: {
                normal: {
                  borderWidth: 0,
                  label: {
                    show: false
                  }
                },

                emphasis: {
                  borderWidth: 0,
                  label: {
                    show: true,
                    color: "#e99314"
                  }
                }
              }
            },

            {
              yAxisIndex: 1,
              data: SValArr,
              type: "line",
              lineStyle: {
                color: "#749f83"
              },

              itemStyle: {
                normal: {
                  borderWidth: 0,
                  label: {
                    show: false
                  }
                },

                emphasis: {
                  borderWidth: 0,
                  label: {
                    show: true,
                    color: "#749f83"
                  }
                }
              }
            }
          ]
        };
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(that.isDkbDeviceCenter ? option2 : option);
      });
    },

    drawLine2() {
      let that = this;
      let { xData, TValArr, HValArr } = that.getLineData();
      console.log("that.getLineData()", that.getLineData());

      let getyAxis = function(unit, color) {
        let yAxis = {
          type: "value",
          name: unit,
          nameTextStyle: {
            color
          }
        };

        return yAxis;
      };
      let getseries = function(data, yAxisIndex, color) {
        let series = {
          data: data,
          type: "line",
          yAxisIndex: yAxisIndex,
          lineStyle: {
            color
          },

          itemStyle: {
            normal: {
              borderWidth: 0,
              label: {
                show: false
              }
            },

            emphasis: {
              borderWidth: 0,
              label: {
                show: true,
                color
              }
            }
          }
        };
        return series;
      };
      let yAxis = [],
        series = [],
        yAxisIndex = 0;
      if (that.wareInfo.temperature) {
        yAxis.push(getyAxis("℃", "#40d6e7"));
        series.push(getseries(TValArr, yAxisIndex, "#40d6e7"));
        yAxisIndex++;
      }
      if (that.wareInfo.humiture) {
        yAxis.push(getyAxis("RH%", "#e99314"));
        series.push(getseries(HValArr, yAxisIndex, "#e99314"));
      }

      this.$nextTick(function() {
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(
          document.getElementById("echartDetail")
        );
        // 绘制图表
        let option = {
          title: {
            left: "2%",
            text: ""
          },

          xAxis: {
            type: "category",
            data: xData,
            // 指示线
            axisPointer: {
              show: true,
              type: "line",
              lineStyle: {
                width: 1,
                type: "dashed",
                color: "#368bac"
              }
            }
          },

          yAxis,
          series
        };

        let htmlFontSize = this.$store.state.htmlFontSize;
        let option2 = {
          grid: {
            top: (100 / 100) * htmlFontSize,
            bottom: (30 / 100) * htmlFontSize,
            left: (40 / 100) * htmlFontSize,
            right: (110 / 100) * htmlFontSize,
            containLabel: true
          },

          xAxis: {
            type: "category",
            data: xData,
            axisLabel: {
              color: "#ffffff"
            },

            // 指示线
            axisPointer: {
              show: true,
              type: "line",
              lineStyle: {
                width: 1,
                type: "dashed",
                color: "#368bac"
              }
            },

            // 坐标轴
            axisLine: {
              onZero: false,
              lineStyle: {
                color: "#3a4a65" // 坐标轴颜色
              }
            },

            axisTick: {
              lineStyle: {
                width: (2 / 100) * htmlFontSize,
                color: "#576d91"
              }
            }
          },

          yAxis: [
            {
              type: "value",
              name: "℃",
              nameTextStyle: {
                color: "#92bd37"
              },

              axisLabel: {
                color: "#ffffff"
              },

              // 坐标轴
              axisLine: {
                onZero: false,
                lineStyle: {
                  color: "#3a4a65" // 坐标轴颜色
                }
              }
            },

            {
              type: "value",
              name: "RH%",
              nameTextStyle: {
                color: "#e99314"
              },

              axisLabel: {
                color: "#ffffff"
              },

              // 坐标轴
              axisLine: {
                onZero: false,
                lineStyle: {
                  color: "#3a4a65" // 坐标轴颜色
                }
              }
            }
          ],
          series: [
            {
              yAxisIndex: 0,
              data: TValArr,
              type: "line",
              lineStyle: {
                color: "#92bd37"
              },

              itemStyle: {
                normal: {
                  borderWidth: 0,
                  label: {
                    show: false
                  }
                },

                emphasis: {
                  borderWidth: 0,
                  label: {
                    show: true,
                    color: "#92bd37"
                  }
                }
              }
            },

            {
              yAxisIndex: 1,
              data: HValArr,
              type: "line",
              lineStyle: {
                color: "#e99314"
              },

              itemStyle: {
                normal: {
                  borderWidth: 0,
                  label: {
                    show: false
                  }
                },

                emphasis: {
                  borderWidth: 0,
                  label: {
                    show: true,
                    color: "#e99314"
                  }
                }
              }
            }
          ]
        };
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(that.isDkbDeviceCenter ? option2 : option);
      });
    },
    //设置箱格名称和标签
    async confirmBoxNameTag() {
      if (vm.boxTagList.length <= 0) {
        showToast("箱格数据不存在");
        return;
    }
      vm.isLoading = true;
      let res = await deviceApi.updateBoxNameAndTag({ data: vm.boxTagList });
      if (res.meta.code == 200) {
        showToast("更新成功");
      } else {
        showToast(res.meta.message);
      }
      vm.showBoxTagPage = false;
      vm.isLoading = false;
    },
    async boxChange(curr) {
      const dataObj = {
        page: curr,
        perPage: vm.boxPaginationParam.page,
        device_no_id: vm.boxTagList[0].device_no_id,
      };
      const res = await deviceApi.getDeviceBoxList(dataObj);
      if (res.meta.code == 200) {
        vm.boxPaginationParam.total = parseInt(res.data.total);
        vm.boxTagList = res.data.list;
      } else {
        vm.isLoading = false;
        showToast(res.meta.message);
      }
    },
    //打开设置
    async openSetting(index) {
      vm.showBoxTagPage = true;
      vm.detailTit = "设置";
      vm.boxPaginationParam.curr = 1;
      //加载箱格详情
      vm.isLoading = true;
      const dataObj = {
        page: vm.boxPaginationParam.curr,
        perPage: vm.boxPaginationParam.page,
        device_no_id: vm.deviceList[index].device_no_id,
      };
      const res = await deviceApi.getDeviceBoxList(dataObj);
      if (res.meta.code == 200) {
        vm.boxPaginationParam.total = parseInt(res.data.total);
        vm.boxTagList = res.data.list;
      } else {
        vm.isLoading = false;
        showToast(res.meta.message);
      }
      vm.isLoading = false;
    },
  },

  watch: {
    // 监听vuex的值变化
    "$store.state.spaceID": async function(newVal, oldVal) {
      if (!this.isDkbDeviceCenter) {
        this.space_id = newVal;
        this.tabActive = "1";
        this.getEquipment();
      }
    },

    /* 车位锁-弹窗记录搜索字段清空时 */
    "recordPaging.user_name"(newVal) {
      if (newVal === "") {
        this.recordPaging.page = 1;
        this.getDeviceRecords("search");
      }
    },

    "recordPaging.user_string"(newVal) {
      if (newVal === "") {
        this.recordPaging.page = 1;
        this.getDeviceRecords("search");
      }
    },

    "recordPaging.timeRange"(newVal) {
      if (newVal === null) {
        this.recordPaging.page = 1;
        this.recordPaging.timeRange = [];
        this.getDeviceRecords("search");
      }
    },

    /* 消毒一体机-操作记录搜索字段清空时 */
    "THAIORecordPaging.device_no_id"(newVal) {
      if (newVal === "") {
        this.THAIORecordPaging.page = 1;
        this.getOperateList("search");
      }
    },

    "THAIORecordPaging.timeRange"(newVal) {
      if (newVal === null) {
        this.THAIORecordPaging.page = 1;
        this.THAIORecordPaging.timeRange = [];
        this.getOperateList("search");
      }
    },

    /* 温湿度传感器-预警记录搜索字段清空时 */
    "EPSENSORWarningPaging.device_no_id"(newVal) {
      if (newVal === "") {
        this.EPSENSORWarningPaging.page = 1;
        this.getExceptionList("search");
      }
    },

    "EPSENSORWarningPaging.exception_type"(newVal) {
      if (newVal === "") {
        this.EPSENSORWarningPaging.page = 1;
        this.getExceptionList("search");
      }
    },

    /** 云视频- 对话框隐藏停止观看直播 */
    VIDEOCLOUDDio(newVal) {
      // console.log(newVal, 'newVal')
      if (newVal === false) {
        vm.VIDEOCLOUDPause();
      }
    }
  }
};
</script>

<style lang="scss">
.CDeviceComponent {
  position: relative;
  .w100{ width: 100px;}
  .w200{ width: 200px;}
  // height: 100%;
  .previewDio {
    .tr {
      text-align: right;
      el-button {
        display: inline-block;
        line-height: 1;
        padding: 12px 20px;
        border: 1px solid #dcdfe6;
        font-size: 14px;
        color: #606266;
        border-radius: 4px;
      }
    }
    .img {
      width: 200px;
      width: 200px;
      margin: 0px auto;
      padding: 20px;
      img{ width:100%; }
    }
    .tips {
      text-align: center;
      color: #f56c6c;
    }
  }
  .noData {
    text-align: center;
    padding: 50px 0;
    font-size: 20px;
    color: #999;
  }
  .detailDio {
    &.secrecyDio {
      .searchDio {
        justify-content: start !important;
      }
    }
    .meterList {
      display: flex;
      width: 100%;
      .echartsDiv {
        flex-grow: 1;
        position: relative;
        .markArea {
          width: 100%;
          display: flex;
          justify-content: center;
          position: absolute;
          bottom: 10px;
          .mark {
            color: #333;
            font-size: 12px;
            position: relative;
            &::before {
              display: block;
                content: '';
              width: 15px;
              height: 2px;
              background-color: #40d6e7;
              position: absolute;
              left: -16px;
              top: 0;
              bottom: 0;
              margin: auto;
            }
            &::after {
              display: block;
                content: '';
              width: 8px;
              height: 8px;
              background-color: #ffffff;
              border-radius: 50%;
              border: 2px solid #40d6e7;
              box-sizing: border-box;
              position: absolute;
              left: -13px;
              top: 0;
              bottom: 0;
              margin: auto;
            }
          }
        }
        .time {
          text-align: center;
          .el-radio__input {
            display: none;
          }
          .el-radio {
            margin-right: 16px;
            &.is-bordered + .el-radio.is-bordered {
              margin-left: 0px;
            }
          }
        }
        .echart {
          height: 226px;
        }
      }
      .meterStatus {
        width: 180px;
        flex-shrink: 0;
        padding: 15px;
        border-right: 2px solid #dcdcdc;
        box-sizing: border-box;
        .item_meter {
          margin-bottom: 15px;
          span {
            font-size: 12px;
            color: #999;
          }
          p {
            font-size: 16px;
            color: #666;
          }
        }
      }
    }
    .paging {
      margin: 20px 0 15px;
    }
    .freshBtn {
      margin: -20px 40px 10px;
    }
    .list_dio {
      margin: 0 45px;
      .colItem {
        border: 1px solid #c5c5c5;
        border-radius: 5px;
        text-align: center;
        box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .3);
        padding: 5px;
        box-sizing: border-box;
        margin-bottom: 19px;
        position: relative;
        .box_check {
          position: absolute;
          left: 0;
          bottom: 0;
          right: 0;
          top: 0;
          margin: 0;
          padding: 0;
          &.is-checked {
            background-color: rgba(255,255,255,.5);
            z-index: 3;
          }
          .el-checkbox__input {
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
            &.is-checked {
              opacity: 1;
            }
          }
          .el-checkbox__label {
            display: none;
          }
        }
        .name {
          font-size: 18px;
          color: #333;
          font-weight: bold;
          margin-bottom: 6px;
          .iconOccupy {
            width: 35px;
            height: 35px;
            // margin-top: -5px;
            // margin-left: 48px;
            fill: currentColor;
            overflow: hidden;
            position: absolute;
            top: 0px;
            right: 0px;
          }
        }
        .tip1 {
          font-size: 12px;
          color: #47ff9d;
          .isIng {
            color: #008cff
          }
          .isNo {
            color: #fd0000
          }
          .isBook {
            color: #e6a23c;
          }
        }
        .tip2 {
          font-size: 12px;
          color: #999;
          .isOpen {
            color: #008cff;
          }
        }
        .btn {
          position: relative;
          z-index: 2;
          .el-loading-spinner {
            margin-top: -10px;
            .circular {
              width: 20px;
              height: 20px;
            }
          }
          em {
            display: inline-block;
            height: 20px;
            line-height: 20px;
            border-radius: 3px;
            font-size: 12px;
            color: #fff;
            padding: 0 14px;
            background-color: #008cff;
            cursor: pointer;
            &.noBtn {
              background-color: #999;
            }
          }
        }
      }
    }
    .tit_dio,
    .search_dio {
      font-size: 18px;
      color: #999;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;
      &.flexStart {
        justify-content: flex-start;
      }
    }
    .tit_dio {
      height: 40px;
      &.flexStart {
        position: relative;
        .flexItem + .flexItem {
          margin-left: 20px;
        }
        .btnSetting {
          position: absolute;
          right: 0;
        }
      }
    }
    .search_dio {
      .text {
        width: 210px;
      }
      .dateText {
        width: 330px;
        margin-left: 20px;
      }
      &.flexStart {
        .text + .text,
        .serchBtn {
          margin-left: 20px;
        }
      }
    }
    .explain {
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      .text {
        font-size: 14px;
        color: #999;
        margin-left: 30px;
      }
    }
    .el-dialog {
      border-radius: 15px;
      overflow: hidden;
      .el-dialog__body {
        padding: 10px 20px;
      }
      .el-dialog__header {
        padding: 16px 18px 18px;
        text-align: center;
        background: #00479d;
        .el-dialog__title {
          color: #fff;
          font-size: 24px;
        }
        .el-dialog__headerbtn {
          font-size: 24px;
          top: 10px;
          .el-dialog__close {
            color: #fff;
          }
        }
      }
    }
    .step {
      padding: 0;
      height: 30px;
      margin: 0 33px 0 18px;
      background: #dadada;
      border-radius: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .item {
        width: 33.33%;
        font-size: 12px;
        color: #fff;
        line-height: 30px;
        text-align: center;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          right: -30px;
          top: 0;
          width: 0;
          height: 0;
          border-width: 15px;
          border-style: solid;
          border-color: transparent transparent transparent #dadada;
          z-index: 10;
        }
        &.activeStep {
          background: #4babfe;
          &::after {
            border-color: transparent transparent transparent #4babfe;
          }
        }
      }
    }
    .Secrecyform {
      margin-top: 20px;
      .el-form-item {
        margin-bottom: 10px;
        .el-form-item__label {
          line-height: 1;
          padding-bottom: 5px;
        }
      }
    }
  }
  .listCont {
    .listTable {
      background: #fff;
      .inlineform {
        padding: 10px;
      }
      .ellipsis {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .paging {
        margin: 0;
        padding: 30px 0;
      }
      .status {
        flex-shrink: 0;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        padding: 0 6px;
        border-radius: 3px;
        color: #fff;
        background: #e65c67;
        &.onLine {
          background: #40e38c;
        }
        &.isNotSet {
          display: none;
        }
      }
    }
    .contBtn {
      .btn {
        background-color: #5c75f3;
        border-color: transparent;
      }
    }
    .list {
      display: flex;
      flex-wrap: wrap;
    }
    .li {
      display: flex;
      position: relative;
      // width: 24%;
      width: 302px;
      min-width: 300px;
      margin-right: 1.333%;
      height: 104px;
      border: 1px solid #f0f0f0;
      border-radius: 10px;
      box-shadow: 0 1px 1px 0 rgba(0,0,0,.2);
      box-sizing: border-box;
      padding: 18px 20px;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 17px;
      font-size: 18px;
      color: #333;
      background-color: #fff;
      // &:nth-child(4n){
      //   margin-right: 0;
      // }
      .ewm {
        position: absolute;
        right: 0px;
        bottom: 0px;
        width: 21px;
        height: 20px;
        background: url('../../../../static/images/icon/icon_ewm.png') no-repeat;
        transition: all .3s;
        &:hover {
          background: url('../../../../static/images/icon/icon_ewm1.png') no-repeat;
        }
      }
      .restart {
        color: #008cff;
        border-color: #008cff;
        padding: 6px 15px;
      }
      .liCont {
        .bot {
          display: flex;
          .detail + .detail {
            margin-left: 20px;
          }
        }
        .detail {
          font-size: 18px;
          color: #008ef2;
          text-decoration: underline;
          position: relative;
          z-index: 2;
        }
        .tip {
          max-width: 180px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .name {
          position: relative;
          max-width: 100%;
          display: flex;
          align-items: center;
          span + span {
            margin-left: 10px;
          }
          span {
            max-width: 180px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .status {
            flex-shrink: 0;
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            padding: 0 6px;
            border-radius: 3px;
            color: #fff;
            background: #e65c67;
            &.onLine {
              background: #40e38c;
            }
            &.isNotSet {
              display: none;
            }
          }
        }
      }
      .liRight {
        position: absolute;
        right: 20px;
      }
      .time {
        position: absolute;
        right: 20px;
        bottom: 15px;
        font-size: 12px;
        color: #999;
      }
    }
    .no-device {
      color: #cccccc;
      text-align: center;
      line-height: 150px;
    }
  }
  .el-switch__label--left {
    position: absolute;
    right: 1px;
    z-index: -1111;
    color: #fff;
  }
  .el-switch__label--right {
    position: absolute;
    left: 1px;
    z-index: -1111;
    color: #fff;
  }
  .el-switch__label.is-active {
    z-index: 1111;
  }
  .el-switch__core {
    height: 28px;
    border-radius: 14px;
    &::after {
      top: 0px;
      width: 26px;
      height: 26px;
    }
  }
  .el-switch.is-checked .el-switch__core::after {
    margin-left: -27px;
  }
  .flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .swiper-container {
    // width: inherit !important;
    // width: 680px;
    width: calc(100vw - 621px);
    min-width: 680px;
    // margin: 0 auto;
    height: 136px;
    .swiper-pagination-bullet {
      width: 10px;
      height: 2px;
    }
    .el-icon-caret-left {
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -18px;
      font-size: 36px;
      color: #999;
      z-index: 999;
      transform: rotate(180deg);
      &.swiper-button-disabled {
        opacity:0
      }
      &.swiper-pagination-bullet-active {
        opacity: 1;
      }
    }
    .el-icon-caret-right {
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -18px;
      font-size: 36px;
      color: #999;
      z-index: 999;
      transform: rotate(180deg);
      &.swiper-button-disabled {
        opacity:0
      }
      &.swiper-pagination-bullet-active {
        opacity: 1;
      }
    }
  }
  .swiper-slide {
    width: inherit !important;
    height: 122px;
    display: flex;
    align-items: center;
    justify-content: center;
    .item {
      flex-shrink: 0;
      width: 98px;
      margin: 0 5px;
      text-align: center;
      &.item:first-child {
        margin-left: 25px;
      }
      &.item:last-child {
        margin-right: 25px;
      }
      .img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background-color: #cce8ff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
      }
      .name {
        margin-top: 10px;
        font-size: 18px;
        color: #999;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &.active {
        .img {
          box-shadow: 0 2px 3px 0 rgba(11,2,5,.49);
          background-color: #008cff;
        }
        .name {
          color: #0081eb;
        }
      }
    }
  }
  .tit {
    height: 48px;
    line-height: 48px;
    background: #d2d2d2;
    font-size: 24px;
    color: #666;
    padding: 0 20px;
    &.dveTit {
      display: flex;
      line-height: 1;
      align-items: center;
      justify-content: space-between;
    }
    .toggIcon {
      .el-radio-group {
        box-shadow:0 0 5px 2px rgba(0,0,0,.28) inset;
        border-radius: 4px;
        background-color: #fff;
      }
      .el-radio-button--small .el-radio-button__inner {
        padding: 7px 13px;
        background-color: transparent;
        border: none;
      }
      .el-radio-button.is-active {
        box-shadow: 0 2px 4px 1px rgba(0,0,0,.2);
      }
      .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: #409eff;
      }
    }
  }
  .bgd2 {
    background-color: #d2d2d2;
  }
  .el-tabs{ background-color: #fff; }
  .el-tabs__active-bar{ display:none;}
  .el-tabs__header {
    background: #f0f0f0;
    margin: 0;
    .el-tabs__item {
      height: 29px;
      line-height: 29px;
      padding: 0px;
      width: 159px;
      font-size: 18px;
      color: #999;
      text-align: center;
      background-color: #e5e5e5;
      &::before {
        content: "";
        position: absolute;
        left: -14px;
        top: 0px;
        width: 0;
        height: 0;
        border-top: 29px solid #e5e5e5;
        border-left: 14px solid transparent;
      }
      &::after {
        content: "";
        position: absolute;
        right: -14px;
        top: 0px;
        width: 0;
        height: 0;
        border-bottom: 29px solid #e5e5e5;
        border-right: 14px solid transparent;
      }
      &.is-active {
        color: #008cff;
        background: #fff;
        &::before {
          content: "";
          border-top: 29px solid #fff;
          border-left: 14px solid transparent;
        }
        &::after {
          content: "";
          border-bottom: 29px solid #fff;
          border-right: 14px solid transparent;
        }
      }
    }
  }
  .el-tabs .no-device {
    line-height: 136px;
    text-align: center;
    color: #cccccc;
  }
  // 智能售卖柜设置
  .SELLBOXSettForm {
    .el-form-item {
      margin-bottom: 0;
    }
    .el-form-item__content {
      display: flex;
      .input {
        width: 150px;
        margin-right: 15px;
      }
    }
    .hint {
      padding-left: 1.5em;
      margin: 10px 0;
      color: #f95757;
      font-size: 12px;
    }
    .col9 {
      color: #999;
    }
  }
  // 温湿度采集器-预警情况-预警设置
  .settingDio {
    .row {
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      .rowTit {
        font-size: 16px;
        font-weight: bold;
        margin-right: 10px;
      }
      .hint {
        font-size: 14px;
        // color: #999;
        color: #f95757;
      }
    }
    .input {
      input {
        text-align: right;
      }
    }
  }
  // 消毒一体机-设置模式
  .THAIOSetDio {
    .btnArea {
      widows: 220px;
      padding-top: 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .btn {
        width: 100px;
        height: 40px;
        line-height: 40px;
        margin-bottom: 20px;
        text-align: center;
        border-radius: 5px;
        background: #fff;
        border: 1px solid #dcdfe6;
        color: #606266;
        &:nth-child(odd) {
          margin-left: 0;
        }
        &:nth-child(even) {
          margin-left: 20px;
        }
        &.active {
          border-color: #0081eb;
          background-color: #0081eb;
          color: #ffffff;
        }
      }
    }
  }
  // 漏水传感器
  // .THAIOSetDio {}
  // 云视频-实时浏览
  .VIDEOCLOUDDio {
    // height: 500px;
    .video {
      width: 100%;
      margin: 10px 0 30px;
    }
    .hint {
      font-size: 16px;
      margin-top: 10px;
      letter-spacing: 2px;
      .refresh {
        font-weight: bold;
        font-weight: bold;
        color: #00479d;
        text-decoration: underline;
      }
    }
  }
  .tagSettingBox {
    padding-left: 15px;
    line-height: 35px;
  }
  .boxTag {
    background: #fff;
    border-width: 0;
  }
  .boxTagItem {
    margin-right: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CSceneManage/CDeviceComponent.vue